import React, { useEffect, useRef, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";
import moment from 'moment';

import { useDispatch, useSelector } from "react-redux";
import Button from './Button';
import Input from './Input';
import InputDate from './InputDate';
import consts from '../libs/consts';

import Radios from './Radios';
import Checkbox from './Checkbox';
import Profiles from './Profiles';
import { close, loadingflas, open, listupdater } from '../redux/popupSlice';
import Select from './Select';
import DaumPostcode from 'react-daum-postcode';
import { anySumFunc, getBase64, getBase64toDataUrl, getMemberinfo, hpHypen, readFile, resizedataURL } from '../utils/utils';
import InfoViewlists from './InfoViewlists';
import * as APIS from "../utils/service";
import DatePicker from "react-datepicker";
import DetailpeeComponent from './DetailpeeComponent';
import { Map, DrawingManager, MarkerClusterer, MapMarker, CustomOverlayMap } from "react-kakao-maps-sdk"
const { kakao } = window;

export default function ProductDetailwrite(props) {

    const {
        setdetailwrite = () => { },
        uidx = null,
        setupdatestatus = () => { },
        row = {},
        setselltypeproduct = () => { },
        setcategory_1product = () => { },
        setcategory_2product = () => { },
    } = props;
    const selectFile = useRef(null);
    const { configdata } = useSelector(s => s.configReducer);
    let wheight = window.innerHeight;

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchactive, setsearchactive] = useState(0);
    const [searchvar, setsearchvar] = useState('');
    const [p_code, setp_code] = useState('');
    const [p_code_sub, setp_code_sub] = useState('');
    const [pcodeDatas, setpcodeDatas] = useState([]);
    const [pcodesubDatas, setpcodesubDatas] = useState([]);
    const [list1Viewer, setlist1Viewer] = useState(0);
    const [list2Viewer, setlist2Viewer] = useState(0);
    const [list3Viewer, setlist3Viewer] = useState(0);
    const [list4Viewer, setlist4Viewer] = useState(0);
    const [list5Viewer, setlist5Viewer] = useState(0);
    const [list6Viewer, setlist6Viewer] = useState(0);
    const [list7Viewer, setlist7Viewer] = useState(0);
    const [list8Viewer, setlist8Viewer] = useState(0);
    const [listdongNames, setlistdongNames] = useState('');
    const [popflag, setpopflag] = useState(false);
    const [latlng, setlatlng] = useState({ lat: 33.450701, lng: 126.570667 });


    const [sell_type, setsell_type] = useState('매매');

    let category_1_setting = configdata?.consts?.category_1_OptionConsts?.map((x, i) => {
        return { labels: x?.title, values: x?.idx }
    })
    let category_2_setting = configdata?.consts?.category_2_OptionConsts?.map((x, i) => {
        return { labels: x?.title, values: x?.idx, category_1: x?.category_1 }
    })
    //console.log(category_2_setting);
    const [category_1_OptionConsts, setcategory_1_OptionConsts] = useState(category_1_setting);
    const [category_2_OptionConsts, setcategory_2_OptionConsts] = useState(category_2_setting);
    const [easy, seteasy] = useState(false);
    const [errmsg, seterrmsg] = useState('');
    const [dateerrmsg, setdateerrmsg] = useState('');
    const [dateerrmsg2, setdateerrmsg2] = useState('');
    const [memberinfos, setmemberinfos] = useState('');

    let firstCategorys = configdata?.consts?.category_1_OptionConsts?.find((x, i) => i === 0)?.idx;
    const [category_1, setcategory_1] = useState(firstCategorys);
    const [category_2, setcategory_2] = useState(configdata?.consts?.category_2_OptionConsts?.find((x, i) => (x?.category_1 === firstCategorys && i === 0))?.idx);
    const [isOpenPost, setIsOpenPost] = useState(false);

    const [addrDatas, setaddrDatas] = useState({});

    const [title, settitle] = useState(''); //건물단지명
    const [keymoneycomment, setkeymoneycomment] = useState(false); //건물단지명

    //inputstyle - 0: 만원, 1: ㎡, 2: 동, 3:층, 4:호, 5: 세대, 6: 차량대수(대), '': 없음
    const [pricesinputArr, setpricesinputArr] = useState([
        { key: 'price_sell', requireCkr: true, inputstyle: 0, titles: '매매가', values: '', input_type: 'text', viewtype: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], viewtype2: ['매매'] },
        { key: 'price_all', requireCkr: true, inputstyle: 0, titles: '보증금', values: '', input_type: 'text', viewtype: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], viewtype2: ['전세', '월세'] },
        { key: 'now_price_all', requireCkr: false, inputstyle: 0, titles: '현보증금', values: '', input_type: 'text', viewtype: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], viewtype2: ['매매'] },
        { key: 'now_price_month', requireCkr: false, inputstyle: 0, titles: '현재월세', values: '', input_type: 'text', viewtype: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], viewtype2: ['매매'] },
        { key: 'price_month', requireCkr: true, inputstyle: 0, titles: '월세', values: '', input_type: 'text', viewtype: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], viewtype2: ['월세'] },
        { key: 'price_keymoney', requireCkr: false, inputstyle: 0, titles: '권리금', values: '', input_type: 'text', viewtype: [5, 6, 7, 8, 9], viewtype2: ['매매', '전세', '월세'] },
        { key: 'price_maintenance', requireCkr: true, inputstyle: 0, titles: '관리비', values: '', input_type: 'text', viewtype: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], viewtype2: ['매매', '전세', '월세'] },
    ]);


    const [productinfoArr, setproductinfoArr] = useState([
        { key: 'area_supply', requireCkr: true, inputstyle: 1, titles: '공급면적', values: '', input_type: 'text', viewtype: [1, 2, 3] },
        { key: 'area_contract', requireCkr: true, inputstyle: 1, titles: '계약면적', values: '', input_type: 'text', viewtype: [4, 5, 6, 7, 8] },
        { key: 'area_private', requireCkr: true, inputstyle: 1, titles: '전용면적', values: '', input_type: 'text', viewtype: [1, 2, 3, 4, 5, 6, 7, 8] },
        { key: 'area_land', requireCkr: true, inputstyle: 1, titles: '토지면적', values: '', input_type: 'text', viewtype: [9, 10, 11] },
        { key: 'area_floor', requireCkr: true, inputstyle: 1, titles: '연면적', values: '', input_type: 'text', viewtype: [9, 10, 11] },
        { key: 'building_dong', requireCkr: false, inputstyle: 2, titles: '동', values: '', input_type: 'text', viewtype: [1, 2, 3, 4, 5, 6, 7, 8] },
        { key: 'building_floor', requireCkr: false, inputstyle: 3, titles: '층', values: '', input_type: 'text', viewtype: [1, 2, 3, 4, 5, 6, 7, 8] },
        { key: 'building_unit', requireCkr: false, inputstyle: 4, titles: '호', values: '', input_type: 'text', viewtype: [1, 2, 3, 4, 5, 6, 7, 8] },
        { key: 'building_dong_floor_all', requireCkr: true, inputstyle: 3, titles: '해당동 총 층', values: '', input_type: 'text', viewtype: [1, 2, 3, 4, 5, 6, 7, 8] },
        { key: 'building_count', requireCkr: false, inputstyle: '', titles: '건물 수', values: '', input_type: 'text', viewtype: [9, 10, 11] },
        { key: 'building_floor_all', requireCkr: true, inputstyle: 3, titles: '지상 총 층', values: '', input_type: 'text', viewtype: [9, 10, 11] },
        { key: 'building_floor_under_all', requireCkr: true, inputstyle: 3, titles: '지하 총 층', values: '', input_type: 'text', viewtype: [9, 10, 11] },
        { key: 'building_unit_all', requireCkr: false, inputstyle: 4, titles: '총 호수', values: '', input_type: 'text', viewtype: [9, 10, 11] },
        { key: 'building_unit_empty', requireCkr: false, inputstyle: '', titles: '공실 수', values: '', input_type: 'text', viewtype: [9, 10, 11] },
        { key: 'item_direction', requireCkr: true, inputstyle: '', titles: '방향', values: '', input_type: 'text', viewtype: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] },
        { key: 'item_direction_standard', requireCkr: true, inputstyle: '', titles: '방향기준', values: '', input_type: 'text', viewtype: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] },
        { key: 'item_room', requireCkr: true, inputstyle: '', titles: '방수', values: '', input_type: 'text', viewtype: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] },
        // {key: 'item_room', requireCkr: true, inputstyle: '', titles: '방수', values: '', input_type: 'text', viewtype: [1,2,3,4,8,11]},
        { key: 'item_bathroom', requireCkr: true, inputstyle: '', titles: '화장실(욕실)수', values: '', input_type: 'text', viewtype: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] },
        { key: 'item_households', requireCkr: false, inputstyle: 5, titles: '세대수', values: '', input_type: 'text', viewtype: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] },
        { key: 'item_elevator', requireCkr: false, inputstyle: 6, titles: '해당동 승강기', values: '', input_type: 'text', viewtype: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] },
        { key: 'item_car_all', requireCkr: true, inputstyle: 6, titles: '총주차대수', values: '', input_type: 'text', viewtype: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] },
        { key: 'item_car', requireCkr: false, inputstyle: 6, titles: '세대당주차', values: '', input_type: 'text', viewtype: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] },
    ]);


    const [item_date, setitem_date] = useState(''); //건축물일자
    const [item_date_type, setitem_date_type] = useState('사용승인일'); //건축물일자 종류
    const [item_move_date, setitem_move_date] = useState(''); //입주가능일
    const [item_move_type, setitem_move_type] = useState(''); //입주가능일 타입
    const [client_name, setclient_name] = useState(''); //의뢰인
    const [client_hp, setclient_hp] = useState(''); //연락처
    const [desc, setdesc] = useState(''); //특이사항
    const [files, setfiles] = useState([]);
    const [delete_files, setdelete_files] = useState([]);

    const [jibhap, setjibhap] = useState('일반');
    const [item_usage, setitem_usage] = useState('공동주택');
    const [plistdong, setplistdong] = useState([]);
    const [plistfloor, setplistfloor] = useState([]);
    const [plistho, setplistho] = useState([]);
    const [listdongv, setlistdongv] = useState('');
    const [listfloorv, setlistfloorv] = useState('');
    const [listhov, setlisthov] = useState('');
    const [listhoaddsv, setlisthoaddsv] = useState([]);
    const [listhoaddsdata, setlisthoaddsdata] = useState([]);
    const [issuetype, setissuetype] = useState([]);
    const [detailpeeJson, setdetailpeeJson] = useState(null);
    const [item_pos_car, setitem_pos_car] = useState('');
    const [itemdesc, setitemdesc] = useState('');
    const [client_type, setclient_type] = useState('');
    const [dongviewer, setdongviewer] = useState('0');
    const [iskeymoney, setiskeymoney] = useState('1');

    const [popupShow, setpopupShow] = useState(false); // 히스토리 팝업
    const [historyList, sethistoryList] = useState([1, 2, 3]); // 히스토리
    const [viewDetailpee, setviewDetailpee] = useState(true); // 관리비 초기화용

    useEffect(() => {
        loadInserHistory();
        dispatch(loadingflas({ loading: false }));
        document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'hidden';
        return () => {
            document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'scroll';
        }
    }, []);

    const [firstLoad, setFirstLoad] = useState(true);

    useEffect(() => {
        if (row?.idx) {
            setsell_type(row?.sell_type);
            setcategory_1(row?.category_1);
            setcategory_2(row?.category_2);
            setp_code_sub(row?.p_code_sub);
            setitem_usage(row?.item_usage);

            console.log(row);
            setaddrDatas({
                addr: row?.addr,
                sido: row?.sido,
                sigungu: row?.sigungu || row?.sido,
                dong: row?.dong || row?.dong
            });
            //document.getElementById("region_name").value = row?.addr;
            settitle(row?.title);

            setlatlng({ lat: row?.lat, lng: row?.lng });

            pricesinputArr?.map((x, i) => {
                setpricesinputArr(pricesinputArr?.map((x2, i2) => {
                    return { ...x2, values: row[x2?.key] };
                }));
            })
            productinfoArr?.map((x, i) => {
                setproductinfoArr(productinfoArr?.map((x2, i2) => {
                    return { ...x2, values: row[x2?.key] };
                }));
            });
            setitem_date(row?.item_date);
            setitem_date_type(row?.item_date_type || '사용승인일');
            setitem_move_date(row?.item_move_date);
            setitem_move_type(row?.item_move_type);
            setclient_name(row?.client_name);
            setclient_hp(row?.client_hp);
            setdesc(row?.desc);

            let files = [];
            row?.files?.map((x, i) => {
                let addfile = {
                    base64: `${consts.s3url}/${x?.file_path}`,
                    file_path: x?.file_path,
                    addtype: false,
                    ext: x?.file_path.split('.')[1]
                }
                files.push(addfile);
            });
            //console.log(files);
            setfiles(files);

            setjibhap(row?.jibhap);
            setdetailpeeJson(row?.detailpeeJson ? JSON.parse(row?.detailpeeJson) : []);
            setissuetype(((row?.issuetype && row?.issuetype * 1 !== 0) ? JSON.parse(row?.issuetype) : []));
            setitemdesc(row?.itemdesc);
            setitem_pos_car(row?.item_pos_car);
            setclient_type(row?.client_type);
            //console.log(row?.hoaddsv?.split(','));
            setlisthoaddsdata(row?.hoaddsv?.split(','));
            let listfirst = [row?.building_unit];
            setlisthoaddsv(listfirst.concat(row?.hoaddsv?.split(',')));

            setlistdongv(row?.building_dong);
            setlistfloorv(row?.building_floor);
            setlisthov(row?.building_unit);
            setiskeymoney(row?.iskeymoney ? "1" : "0")

            if (row?.status * 1 === 98) {

                setTimeout(() => {
                    setp_code(row?.p_code); // p_code 가 업데이트 되면 표제부랑 호출
                }, 1000);
                pcodeChangeFunc(row?.p_code);
                setlistdongv('');
                setlistfloorv('');
                setlisthov('');
            } else {
                setp_code(row?.p_code); // p_code 가 업데이트 되면 표제부랑 호출

                setlistdongv(row?.building_dong);
                setlistfloorv(row?.building_floor);
                setlisthov(row?.building_unit);
            }

            // 지번 노출설정
            // if([1,2,3,4,8].includes(row?.category_2*1)){
            //     setdongviewer("0")
            // } else {
            //     setdongviewer(row?.dongviewer)
            // }
            //alert(row?.dongviewer);
            setdongviewer(row?.dongviewer ? '1' : '0');
            //setdongviewer(dv)


            setTimeout(() => {
                setlistdongProc();
            }, 200);
        } else {
            setFirstLoad(false);
        }
    }, [row]);


    useEffect(() => {
        seterrmsg('');
        setdateerrmsg('');
    }, [
        sell_type, category_1, category_2, addrDatas, title, pricesinputArr, productinfoArr,
        item_date, item_date_type, item_move_date, item_move_type,
        client_name, client_hp, desc, files
    ]);

    // 카테고리2 변화에 따른 용도 자동선택
    const setDefaultUsage = (cate2) => {
        if (cate2 == 1) { // 아파트
            setitem_usage("공동주택")
        } else if (cate2 == 2) { // 다세대
            setitem_usage("공동주택")
        } else if (cate2 == 3) { // 단독/다가구
            setitem_usage("단독주택")
        } else if (cate2 == 4) { // 오피스텔
            setitem_usage("업무시설")
        } else if (cate2 == 5) { // 상가
            setitem_usage("제2종 근린생활시설")
        } else if (cate2 == 6) { // 사무실
            setitem_usage("업무시설")
        } else if (cate2 == 7) { // 지식산업센터
            setitem_usage("공장")
        } else if (cate2 == 8) { // 오피스텔
            setitem_usage("업무시설")
        } else if (cate2 == 9) { // 빌딩,상업용건물
            setitem_usage("제2종 근린생활시설")
        } else if (cate2 == 10) { // 상가주택
            setitem_usage("단독주택")
        } else if (cate2 == 11) { // 주거전용건물
            setitem_usage("단독주택")
        }
    }

    // 거래 형태 변화에 따른 의뢰인 타입 자동선택
    const setDefaultClientType = (sellType) => {
        if (sellType == "매매") {
            setclient_type("매도인")
        } else if (sellType == "전세") {
            setclient_type("임대인")
        } else if (sellType == "월세") {
            setclient_type("임대인")
        }
    }
    useEffect(() => {
        if(row?.idx === ''){
            if (sell_type == "매매") {
                setclient_type("매도인")
            } else if (sell_type == "전세") {
                setclient_type("임대인")
            } else if (sell_type == "월세") {
                setclient_type("임대인")
            }
        }
    }, [sell_type, row])

    const onCompletePost = (data) => {
        setpcodeDatas([]);
        setp_code('');
        setp_code_sub('');
        let fullAddr = data.address;
        let extraAddr = '';

        console.log('data', data);

        //let jibunAddress = jibunAddress;

        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddr += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddr += extraAddr !== '' ? `, ${data.buildingName}` : data.buildingName;
            }
            fullAddr += extraAddr !== '' ? ` (${extraAddr})` : '';
        }
        let p_code = data?.bcode;
        let jibunex = data?.autoJibunAddress ? data?.autoJibunAddress.split(' ') : data?.jibunAddress.split(' ');
        let mountain_yn = jibunex[jibunex?.length - 2] === '산' ? '1' : '0';
        let address_no_ex = jibunex[jibunex?.length - 1].split('-');
        let main_address_no = address_no_ex[0];
        let sub_address_no = address_no_ex[1];
        p_code += mountain_yn;
        p_code += main_address_no?.padStart(4, "0");
        p_code += sub_address_no ? sub_address_no?.padStart(4, "0") : '0000';
        //p_code 식별코드 확인후 총괄표제부 등등 확인
        // 4688037022101240000
        // 4688037022101240000
        setlist1Viewer(0);
        setlist2Viewer(0);
        setp_code(p_code);
        pcodeChangeFunc(p_code);
        let p_code_subs = data?.sigunguCode + data?.roadnameCode;
        setp_code_sub(p_code_subs);
        //console.log(p_code, jibunex, mountain_yn, address_no_ex, jibunex[jibunex?.length-2]);

        setaddrDatas({
            addr: data.address,
            sido: data?.sido,
            sigungu: data?.sigungu || data?.sido,
            dong: data?.bname1 || data?.bname
        });
        setlatlng({ lat: 33.450701, lng: 126.570667 });

        Promise.resolve(data).then(o => {
            const { address } = data;

            return new Promise((resolve, reject) => {
                const geocoder = new kakao.maps.services.Geocoder();

                geocoder.addressSearch(address, (result, status) => {
                    if (status === kakao.maps.services.Status.OK) {
                        const { x, y } = result[0];
                        setlatlng({ lat: y, lng: x });
                        //resolve({ lat: y, lon: x })
                    } else {
                        reject();
                    }
                });
            })
        }).then(result => {
            // 위, 경도 결과 값
        });
        setlistdongv('');
        setlistfloorv('');

        setIsOpenPost(false);
    };
    const postBoxStyle = {
        display: 'block',
        position: 'relative',
        width: '100%',
        border: '1px solid #000',
        marginTop: 5,
        textAlign: 'right'
    };
    const postCodeStyle = {
        width: '100%',
        borderTop: '1px solid #000',
    };

    /**
     * 등록 하기
     * @param {*} uidx 
     * @param {*} removed 
     * @returns 
     */
    const simpleWirteSubmit = (uidx = null, removed = false) => {

        // sell_type, category_1, category_2, addrDatas, building_dong, building_floor, building_unit,
        // price_sell, now_price_all, now_price_month, price_all, price_month, price_keymoney, price_maintenance, price_maintenance,
        // area_supply, area_contract, area_private, building_count, building_floor_all, building_floor_under_all, area_land, area_floor,
        // client_name, client_hp
        //console.log("addrDatas", addrDatas);

        let inputsdefaultsArr = [
            { values: sell_type, comments: '거래형태를', comment_types: '선택' },
            { values: category_1, comments: '매물종류를', comment_types: '선택' },
            { values: category_2, comments: '하위매물종류를', comment_types: '선택' },
            { values: addrDatas?.addr || '', comments: '소재지를', comment_types: '검색' },
        ];
        let requireCkrs = "";
        for (let c = 0; c < inputsdefaultsArr?.length; c++) {
            if (inputsdefaultsArr[c]?.values === '') {
                if (requireCkrs === "") {
                    requireCkrs += inputsdefaultsArr[c]?.comments.replace('를', '').replace('을', '');
                } else {
                    requireCkrs += ", " + inputsdefaultsArr[c]?.comments.replace('를', '').replace('을', '');
                }
            }
            // if(inputsdefaultsArr[c]?.values === ''){
            //     seterrmsg(`${inputsdefaultsArr[c]?.comments} ${inputsdefaultsArr[c]?.comment_types}해주세요.`);
            //     return;
            // }
        }



        for (let c = 0; c < pricesinputArr?.length; c++) {
            if (!pricesinputArr[c]?.viewtype?.find((x) => x * 1 === category_2 * 1)) {
                continue;
            }
            if (!pricesinputArr[c]?.viewtype2?.find((x) => x === sell_type)) {
                continue;
            }

            if (pricesinputArr[c]?.requireCkr === true && pricesinputArr[c]?.values === '') {
                // seterrmsg(`${pricesinputArr[c]?.titles}를(을) 입력해 주세요.`);
                // return;
                if (requireCkrs === "") {
                    requireCkrs += pricesinputArr[c]?.titles;
                } else {
                    requireCkrs += ", " + pricesinputArr[c]?.titles;
                }
                //return;
            }
        }
        for (let c = 0; c < productinfoArr?.length; c++) {
            if (productinfoArr[c]?.key === "item_room" && [5, 6, 7, 9].includes(category_2 * 1)) {
                console.log("방수 안해도됨")
                continue;
            }
            //console.log(productinfoArr[c]?.titles, productinfoArr[c]?.key, pricesinputArr[c]?.viewtype);
            //console.log('???', productinfoArr[c]?.viewtype?.find((x) => x*1 === category_2*1) );
            if (!productinfoArr[c]?.viewtype?.find((x) => x * 1 === category_2 * 1)) {
                continue;
            }
            if (productinfoArr[c]?.requireCkr === true && productinfoArr[c]?.values === '') {
                // seterrmsg(`${productinfoArr[c]?.titles}를(을) 입력해 주세요.`);
                // return;
                if (requireCkrs === "") {
                    requireCkrs += productinfoArr[c]?.titles;
                } else {
                    requireCkrs += ", " + productinfoArr[c]?.titles;
                }
            }
        }
        inputsdefaultsArr = [
            { values: item_date, comments: '건축물일자를', comment_types: '입력' },
            { values: item_date_type, comments: '건축물일자 종류를', comment_types: '선택' },
            { values: item_move_date, comments: '입주가능일을', comment_types: '입력' },
            // {values: client_name, comments: '의뢰인을', comment_types: '입력'},
            { values: client_hp, comments: '연락처를', comment_types: '입력' },
        ];
        for (let c = 0; c < inputsdefaultsArr?.length; c++) {
            if (inputsdefaultsArr[c]?.values === '') {
                if (requireCkrs === "") {
                    requireCkrs += inputsdefaultsArr[c]?.comments.replace('를', '').replace('을', '');
                } else {
                    requireCkrs += ", " + inputsdefaultsArr[c]?.comments.replace('를', '').replace('을', '');
                }
            }
            if (inputsdefaultsArr[c]?.values !== '' && inputsdefaultsArr[c]?.comments === '건축물일자를') {
                if (moment(item_date).format('YYYY-MM-DD') === 'Invalid date' || item_date?.length < 8) {
                    if (requireCkrs === "") {
                        requireCkrs += inputsdefaultsArr[c]?.comments.replace('를', '').replace('을', '');
                    } else {
                        requireCkrs += ", " + inputsdefaultsArr[c]?.comments.replace('를', '').replace('을', '');
                    }
                }
            }
            // if(inputsdefaultsArr[c]?.values === ''){
            //     seterrmsg(`${inputsdefaultsArr[c]?.comments} ${inputsdefaultsArr[c]?.comment_types}해주세요.`);
            //     return;
            // }
        }


        if (requireCkrs !== '') {
            seterrmsg(`필수 입력 사항을 확인하세요.(${requireCkrs})`);
            return;
        }

        let fileSetting = [];
        files?.map((x, i) => {
            //console.log(x?.base);
            fileSetting.push({ base: x?.base, ext: x?.ext });
        });

        let sender = {
            idx: uidx,
            easy: easy,
            sell_type: sell_type,
            title: title,
            category_1: category_1,
            category_2: category_2,
            sido: addrDatas?.sido,
            sigungu: addrDatas?.sigungu,
            dong: addrDatas?.dong,
            addr: addrDatas?.addr,
            item_date_type: item_date_type,
            item_date: item_date,
            item_move_date: item_move_date,
            item_move_type: item_move_type,
            client_name: client_name,
            client_hp: client_hp,
            desc: desc,
            files: fileSetting,
            delete_files: delete_files,
            jibhap: jibhap,
            issuetype: JSON.stringify(issuetype),
            detailpeeJson: JSON.stringify(detailpeeJson),
            itemdesc: itemdesc,
            item_usage: item_usage,
            client_type: client_type,
            hoaddsv: listhoaddsv?.filter((item, index) => index > 0)?.map((item, index) => item)?.join(","),
            item_pos_car: item_pos_car,
            p_code_sub: p_code_sub,
            dongviewer: dongviewer,
            iskeymoney: iskeymoney
        }
        // console.log("@@@",sender);
        // return;
        pricesinputArr?.map((x, i) => {
            if (
                x.key === 'price_sell' ||
                x.key === 'now_price_all' ||
                x.key === 'now_price_month' ||
                x.key === 'price_all' ||
                x.key === 'price_month' ||
                x.key === 'price_keymoney' ||
                x.key === 'price_maintenance'
            ) {
                sender[x.key] = x?.values * 1;
            } else {
                sender[x.key] = x?.values;
            }
        })
        productinfoArr?.map((x, i) => {
            sender[x.key] = x?.values;
        })
        console.log(pricesinputArr)
        console.log(productinfoArr)
        console.log("????????", sender);
        //return;
        dispatch(
            open({
                component: '등록하시겠습니까?',
                title: '알림',
                button: "등록",
                buttonCencle: "취소",
                titleviewer: true,
                alert: false,
                onPress: () => {
                    dispatch(loadingflas({ loading: true }));
                    APIS.postData('/v1/item/insert', sender).then(({ data }) => {
                        if (data) {
                            //console.log(data);
                            dispatch(close());
                            setdetailwrite(false);
                            setupdatestatus(true);
                            dispatch(listupdater({ listupdate: true }));

                            navigate("/Product", {
                                state: {
                                    type: "insertProduct",
                                    sell_type: sell_type,
                                    category_1: category_1 * 1,
                                }
                            });

                            dispatch(
                                open({
                                    component: `${uidx !== null ? '매물이 수정되었습니다.' : '매물이 등록되었습니다.\n외부공개를 원치 않으시면 확인 후 꺼주시기 바랍니다.\n*외부공개가 켜져있으면 미니홈, 점포거래소 등 외부에 공개됩니다. 자세한 내용은 이용가이드를 확인해주세요.'}`,
                                    title: '알림',
                                    titleviewer: true,
                                    alert: false,
                                    button: "확인",
                                    onPress: () => {
                                        setselltypeproduct(sell_type);
                                        setcategory_1product(category_1 * 1);
                                        setcategory_2product(category_2 * 1);
                                        dispatch(close());
                                    }
                                })
                            );
                        }
                    }).catch(({ response }) => {
                        const { data } = response;
                        console.log(data);
                        dispatch(
                            open({
                                component: '해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.',
                                title: '알림',
                                button: "확인",
                                titleviewer: true,
                                alert: false,
                                onPress: () => {
                                    dispatch(close());
                                },
                            })
                        );
                    }).finally(() => {
                        dispatch(loadingflas({ loading: false }));
                    });
                },
                onCancelPress: () => {
                    dispatch(close());
                }
            })
        );


    }

    useEffect(() => {
        if (p_code !== '') {
            pcodeChangeFunc(p_code);
        }
    }, [p_code]);

    const groupBy = (xs, key) => {
        return xs?.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    }
    useEffect(() => {
        setlistdongProc();
    }, [pcodeDatas, listdongv, listfloorv]);

    const setlistdongProc = () => {
        console.log(pcodeDatas);
        let inputArrData = productinfoArr;
        let keydongs = [];
        let keyfloors = [];
        let holists = [];
        if (pcodeDatas['전유공용']?.length > 0) {
            // pcodeDatas['표제부']?.find((item, index) => index === list2Viewer)?.['대장종류코드명'] === '일반건축물' &&
            // pcodeDatas['표제부']?.find((item, index) => index === list2Viewer)?.['대장종류코드명'] === '표제부' &&

            if (pcodeDatas['표제부']?.find((item, index) => index === list2Viewer)?.['대장종류코드명'] === '일반건축물') {
                let setArrs = pcodeDatas['층별개요']?.map(x => {
                    x['층이름'] = `${x['층구분코드명']} ${x['층번호']}층`;
                    x['정렬'] = `${x['층구분코드명'] === '지하' ? 'a' : 'b'}${x['층번호'] * 1 < 10 ? '0' + x['층번호'] : x['층번호']}`;
                    return x;
                })
                setArrs?.sort((a, b) => {
                    return a['정렬'] < b['정렬'] ? -1 : a['정렬'] > b['정렬'] ? 1 : 0;
                });
                let floorlists = [];
                if (listdongv) {
                    // floorlists = setArrs?.filter(item => item['동명'] === listdongv && item['전유공용구분코드']*1 === 1 );
                    floorlists = setArrs?.filter(item => item['동명'] === listdongv);
                }


                let groubedByTeam = groupBy(setArrs, '동명');
                let listfloors = [];
                if (listdongv) {
                    listfloors = groupBy(floorlists?.filter(item => item['동명'] === listdongv), '층이름');
                } else {
                    listfloors = groupBy(setArrs, '층이름');
                }

                keydongs = Object.keys(groubedByTeam)?.filter(item => item !== '');

                keyfloors = Object.keys(listfloors);
                // //console.log(Object.keys(reviewOptions), type0filter, type1filter);
                keydongs = keydongs?.map((x, i) => {
                    return { labels: x, values: x }
                })
                keyfloors = keyfloors?.map((x, i) => {
                    //console.log("xxx", listfloors);
                    return { labels: x, values: x }
                })

                console.log("holistsholistsholists??????????", listdongv, listfloorv, listhov);
                // console.log("keyfloorskeyfloorskeyfloorskeyfloors", listdongv, keyfloors, listfloorv);

                keydongs.sort((a, b) => {
                    return a.labels < b.labels ? -1 : a.labels > b.labels ? 1 : 0;
                });

            } else {
                let setArrs = pcodeDatas['전유공용']?.map(x => {
                    x['층이름'] = `${x['층구분코드명']} ${x['층번호']}층`;
                    x['정렬'] = `${x['층구분코드명'] === '지하' ? 'a' : 'b'}${x['층번호'] * 1 < 10 ? '0' + x['층번호'] : x['층번호']}`;
                    return x;
                })
                setArrs?.sort((a, b) => {
                    return a['정렬'] < b['정렬'] ? -1 : a['정렬'] > b['정렬'] ? 1 : 0;
                });

                let floorlists = [];
                if (listdongv) {
                    floorlists = setArrs?.filter(item => item['동명'] === listdongv && item['전유공용구분코드'] * 1 === 1);
                }


                let groubedByTeam = groupBy(setArrs, '동명');
                let listfloors = [];
                if (listdongv) {
                    listfloors = groupBy(floorlists?.filter(item => item['동명'] === listdongv), '층이름');
                } else {
                    listfloors = groupBy(setArrs, '층이름');
                }
                keydongs = Object.keys(groubedByTeam)?.filter(item => item !== '');

                keyfloors = Object.keys(listfloors);
                // //console.log(Object.keys(reviewOptions), type0filter, type1filter);
                keydongs = keydongs?.map((x, i) => {
                    return { labels: x, values: x }
                })
                keyfloors = keyfloors?.map((x, i) => {
                    //console.log("xxx", listfloors);
                    return { labels: x, values: x }
                })

                holists = [];
                if (!listfloorv) {
                    holists = setArrs?.filter(item => item['층이름'] === keyfloors[0]?.values && item['전유공용구분코드'] * 1 === 1)?.map((x, i) => {
                        return { labels: x['호명'], values: x['호명'] }
                    })
                } else {
                    if (listdongv) {
                        holists = setArrs?.filter(item => item['동명'] === listdongv && item['층이름'] === listfloorv && item['전유공용구분코드'] * 1 === 1)?.map((x, i) => {
                            return { labels: x['호명'], values: x['호명'] }
                        })
                    } else {
                        holists = setArrs?.filter(item => item['층이름'] === listfloorv && item['전유공용구분코드'] * 1 === 1)?.map((x, i) => {
                            return { labels: x['호명'], values: x['호명'] }
                        })
                    }
                }
                //console.log("holistsholistsholists??????????", listdongv, listfloorv, listhov);
                // console.log("keyfloorskeyfloorskeyfloorskeyfloors", listdongv, keyfloors, listfloorv);

                keydongs.sort((a, b) => {
                    return a.labels < b.labels ? -1 : a.labels > b.labels ? 1 : 0;
                });
                holists.sort((a, b) => {
                    return a.labels < b.labels ? -1 : a.labels > b.labels ? 1 : 0;
                });
                holists = holists.filter(function (item1, idx1) {
                    //filter() 메서드는 콜백함수에서 정의한 조건이 true인 항목만 리턴한다.(필터링)
                    return holists.findIndex(function (item2, idx) {
                        //findIndex() 메서드는 콜백함수에 정의한 조건이 true인 항목의 index를 리턴한다.
                        return item1.labels == item2.labels
                    }) == idx1;
                });
            }


            setplistdong(keydongs);
            setplistfloor(keyfloors);
            setplistho(holists);



            console.log("holistsholistsholists??????????", listdongv, listfloorv, listhov);
            if (!listdongv) {
                setlistdongv(keydongs[0]?.values);
                //inputArrData = inputArrData?.map((x2, i2) => x2?.key === 'building_dong' ? { ...x2, values: "" } : x2);
            } else {

            }

            if (keyfloors?.filter(item => item?.values === listfloorv)?.length < 1) {
                console.log("mmmmmmmm")
                setlistfloorv(keyfloors[0]?.values);
                //inputArrData = inputArrData?.map((x2, i2) => x2?.key === 'building_floor' ? { ...x2, values: keyfloors[0]?.values } : x2);
            }

            if (!listhov) {
                setlisthov(holists[0]?.values);
                //inputArrData = inputArrData?.map((x2, i2) => x2?.key === 'building_unit' ? { ...x2, values: holists[0]?.values } : x2);
            }
            console.log(inputArrData);
            setproductinfoArr(inputArrData);
            if (!row?.idx) {
                setlisthoaddsv([holists[0]?.values]);
            }
        }
    }

    // 식별코드에 따른 부동산 정보 가져오기
    const pcodeChangeFunc = (codes) => {
        let sender = {
            code: codes
        }
        console.log(sender);
        APIS.postData('/v1/item/getData', sender).then(({ data }) => {
            if (data) {
                //console.log("?????????", data);
                let searchlist = data['부속지번'];
                //console.log(searchlist);
                let subpcodeData = [];
                searchlist?.map((x, i) => {
                    //console.log(x);
                    let pcodes = `${x['부속시군구코드']}${x['부속법정동코드']}${(x['부속대지구분코드'] * 1 === 0 ? 1 : x['부속대지구분코드'] * 1 === 1 ? 2 : x['부속대지구분코드'] * 1)}${x['부속번']}${x['부속지']}`;
                    subpcodeData.push(pcodes);
                });

                sender = {
                    code: subpcodeData
                }
                APIS.postData('/v1/item/getDatasub', sender).then(({ data }) => {
                    if (data) {
                        //console.log("?????????", data);
                        //subpcodeData.push(data);
                        setpcodesubDatas(data);
                    }
                }).catch(({ response }) => {
                    //console.log(data);
                }).finally(() => {
                    dispatch(loadingflas({ loading: false }));
                });

                //console.log(subpcodeData);
                let selectlists = data['표제부']?.map((x, i) => {
                    return { labels: `${x['동명'] || ''}`, values: i }
                });
                console.log("ㄴㄴㄴㄴㄴ", selectlists[0]?.labels);
                setlistdongNames(selectlists[0]?.labels || '');
                setpcodeDatas(data);
                console.log(data);

                if (firstLoad) { // 수정시 첫 로딩이면 데이터 입력처리 X
                    setFirstLoad(false);
                    return
                }

                if (data['총괄표제부']?.length > 0) {
                    settitle(data['총괄표제부'][0]['건물명'] || data['표제부'][0]['건물명']);
                    setjibhap(data['총괄표제부'][0]['대장구분코드명'] || '일반');
                    //const [item_date_type, setitem_date_type] = useState('사용승인일'); //건축물일자 종류
                    setitem_date(!data['총괄표제부'][0]['사용승인일'] ? moment(data['표제부'][0]['사용승인일']).format('YYYY-MM-DD') : moment(data['총괄표제부'][0]['사용승인일']).format('YYYY-MM-DD'));
                    let productinfoArrAuto = productinfoArr;
                    productinfoArrAuto = productinfoArrAuto?.map((x, i) => {
                        if (x?.key === 'item_households') {
                            let item_households_all_Count = 0;
                            data['표제부']?.map((x2, i2) => {
                                item_households_all_Count = item_households_all_Count + (x2['세대수'] * 1);
                            });
                            return { ...x, values: data['총괄표제부'][0]['세대수'] * 1 > 0 ? data['총괄표제부'][0]['세대수'] * 1 : item_households_all_Count };
                        } else if (x?.key === 'item_car_all') {
                            let call_all_Count = ((data['총괄표제부'][0]['옥내기계식대수'] * 1) + (data['총괄표제부'][0]['옥외기계식대수'] * 1)) + ((data['총괄표제부'][0]['옥내자주식대수'] * 1) + (data['총괄표제부'][0]['옥외자주식대수'] * 1));
                            if (call_all_Count === 0) {
                                data['표제부']?.map((x2, i2) => {
                                    call_all_Count = call_all_Count + ((x2['옥내기계식대수'] * 1) + (x2['옥외기계식대수'] * 1)) + ((x2['옥내자주식대수'] * 1) + (x2['옥외자주식대수'] * 1));
                                });
                            }
                            console.log("call_all_Countcall_all_Countcall_all_Count", call_all_Count);
                            return { ...x, values: call_all_Count };
                        } else if (x?.key === 'item_car') {
                            let call_all_Count = ((data['총괄표제부'][0]['옥내기계식대수'] * 1) + (data['총괄표제부'][0]['옥외기계식대수'] * 1)) + ((data['총괄표제부'][0]['옥내자주식대수'] * 1) + (data['총괄표제부'][0]['옥외자주식대수'] * 1));
                            call_all_Count = call_all_Count * 1;
                            if (call_all_Count === 0) {
                                data['표제부']?.map((x2, i2) => {
                                    call_all_Count = call_all_Count + (x2['옥외자주식대수'] * 1);
                                });
                            }
                            let item_households_all_Count = data['총괄표제부'][0]['세대수'] || 0;
                            item_households_all_Count = item_households_all_Count * 1;
                            if (item_households_all_Count === 0) {
                                data['표제부']?.map((x2, i2) => {
                                    item_households_all_Count = item_households_all_Count + (x2['세대수'] * 1);
                                });
                            }
                            console.log(call_all_Count, item_households_all_Count);
                            return { ...x, values: item_households_all_Count <= 0 ? "" : Math.round(call_all_Count / item_households_all_Count * 100) / 100 };
                        } else {
                            return x;
                        }
                    });
                    console.log(productinfoArrAuto);
                    setproductinfoArr(productinfoArrAuto);
                } else {
                    //총괄 표제부가 없는경우 표제부 정보로 출력
                    if (data['표제부'].length > 0) {
                        settitle(data['표제부'][0]['건물명']);
                        setjibhap(data['표제부'][0]['대장구분코드명']);
                        setitem_date(moment(data['표제부'][0]['사용승인일']).format('YYYY-MM-DD'));

                        let productinfoArrAuto = productinfoArr;
                        productinfoArrAuto = productinfoArrAuto?.map((x, i) => {
                            if (x?.key === 'item_households') {
                                let item_households_all_Count = 0;
                                data['표제부']?.map((x2, i2) => {
                                    item_households_all_Count = item_households_all_Count + (x2['세대수'] * 1);
                                });
                                return { ...x, values: data['표제부'][0]['세대수'] * 1 > 0 ? data['표제부'][0]['세대수'] * 1 : item_households_all_Count };
                            } else if (x?.key === 'item_car_all') {
                                let call_all_Count = ((data['표제부'][0]['옥내기계식대수'] * 1) + (data['표제부'][0]['옥외기계식대수'] * 1)) + ((data['표제부'][0]['옥내자주식대수'] * 1) + (data['표제부'][0]['옥외자주식대수'] * 1));
                                if (call_all_Count === 0) {
                                    data['표제부']?.map((x2, i2) => {
                                        call_all_Count = call_all_Count + ((x2['옥내기계식대수'] * 1) + (x2['옥외기계식대수'] * 1)) + ((x2['옥내자주식대수'] * 1) + (x2['옥외자주식대수'] * 1));
                                    });
                                }
                                // console.log("call_all_Countcall_all_Countcall_all_Count", call_all_Count);
                                return { ...x, values: call_all_Count };
                            } else if (x?.key === 'item_car') {
                                let call_all_Count = ((data['표제부'][0]['옥내기계식대수'] * 1) + (data['표제부'][0]['옥외기계식대수'] * 1)) + ((data['표제부'][0]['옥내자주식대수'] * 1) + (data['표제부'][0]['옥외자주식대수'] * 1));
                                call_all_Count = call_all_Count * 1;
                                if (call_all_Count === 0) {
                                    data['표제부']?.map((x2, i2) => {
                                        call_all_Count = call_all_Count + (x2['옥외자주식대수'] * 1);
                                    });
                                }
                                let item_households_all_Count = data['표제부'][0]['세대수'] || 0;
                                item_households_all_Count = item_households_all_Count * 1;
                                if (item_households_all_Count === 0) {
                                    data['표제부']?.map((x2, i2) => {
                                        item_households_all_Count = item_households_all_Count + (x2['세대수'] * 1);
                                    });
                                }
                                console.log(call_all_Count, item_households_all_Count);
                                return { ...x, values: item_households_all_Count <= 0 ? "" : Math.round(call_all_Count / item_households_all_Count * 100) / 100 };
                            } else {
                                return x;
                            }
                        });
                        setproductinfoArr(productinfoArrAuto);
                    }
                }
            }
        }).catch(({ response }) => {
            const { data } = response;
            console.log(data);
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
    }

    useEffect(() => {
        console.log(pcodesubDatas);
    }, [pcodesubDatas]);

    const messagePopup = (msg) => {
        dispatch(
            open({
                component: msg,
                title: '알림',
                button: "확인",
                titleviewer: true,
                alert: false,
                onPress: () => {
                    dispatch(close());
                },
            })
        );
    }

    const historySaveCheck = (callback) => {
        if (
            addrDatas?.sido &&
            addrDatas?.sigungu
        ) {
            let sender = {
                history: true,
                sell_type: sell_type,
                title: title,
                category_1: category_1,
                category_2: category_2,
                sido: addrDatas?.sido,
                sigungu: addrDatas?.sigungu,
                dong: addrDatas?.dong,
                addr: addrDatas?.addr,
                item_date_type: item_date_type,
                item_date: item_date,
                item_move_date: item_move_date,
                item_move_type: item_move_type,
                client_name: client_name,
                client_hp: client_hp,
                desc: desc,
                delete_files: delete_files,
                jibhap: jibhap,
                issuetype: JSON.stringify(issuetype),
                detailpeeJson: JSON.stringify(detailpeeJson),
                itemdesc: itemdesc,
                item_usage: item_usage,
                client_type: client_type,
                hoaddsv: listhoaddsv?.filter((item, index) => index > 0)?.map((item, index) => item)?.join(","),
                item_pos_car: item_pos_car,
                p_code_sub: p_code_sub,
                dongviewer: dongviewer,
                iskeymoney: iskeymoney
            }
            pricesinputArr?.map((x, i) => {
                if (
                    x.key === 'price_sell' ||
                    x.key === 'now_price_all' ||
                    x.key === 'now_price_month' ||
                    x.key === 'price_all' ||
                    x.key === 'price_month' ||
                    x.key === 'price_keymoney' ||
                    x.key === 'price_maintenance'
                ) {
                    sender[x.key] = x?.values * 1;
                } else {
                    sender[x.key] = x?.values;
                }
            })
            productinfoArr?.map((x, i) => {
                sender[x.key] = x?.values;
            })

            dispatch(
                open({
                    component: <div style={{ textAlign: "center" }}>
                        등록이 완료되지 않았습니다.<br />
                        작성중인 내용을 임시저장 하시겠습니까?
                    </div>,
                    title: '알림',
                    button: "임시저장",
                    buttonCencle: "저장하지 않고 닫기",
                    titleviewer: true,
                    alert: false,
                    onPress: () => {
                        dispatch(close());
                        APIS.postData('/v1/item/insert', sender).then(({ data }) => {
                            messagePopup("임시저장 되었습니다.")
                            loadInserHistory();
                            callback();
                        }).catch(({ response }) => {
                            const { data } = response;
                            console.log(response);
                            messagePopup("해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.")
                        }).finally(() => {
                        });
                    },
                    onCancelPress: () => {
                        callback();
                        dispatch(close());
                    }
                })
            );
        } else {
            callback();
        }
    }

    const importHistory = (data) => {
        console.log("datadatadatadata", data);
        setsell_type(data?.sell_type);
        setcategory_1(data?.category_1);
        setcategory_2(data?.category_2);
        setp_code_sub(data?.p_code_sub);
        setitem_usage(data?.item_usage);

        setaddrDatas({
            addr: data?.addr,
            sido: data?.sido,
            sigungu: data?.sigungu || data?.sido,
            dong: data?.dong || data?.dong
        });
        settitle(data?.title);

        setlatlng({ lat: data?.lat, lng: data?.lng });

        pricesinputArr?.map((x, i) => {
            setpricesinputArr(pricesinputArr?.map((x2, i2) => {
                console.log(data[x2?.key]);

                return { ...x2, values: data[x2?.key] };
            }));
        })
        productinfoArr?.map((x, i) => {
            setproductinfoArr(productinfoArr?.map((x2, i2) => {
                return { ...x2, values: data[x2?.key] };
            }));
        });
        setitem_date(data?.item_date);
        setitem_date_type(data?.item_date_type || '사용승인일');
        setitem_move_date(data?.item_move_date);
        setitem_move_type(data?.item_move_type);
        setclient_name(data?.client_name);
        setclient_hp(data?.client_hp);
        setdesc(data?.desc);

        let files = [];
        data?.files?.map((x, i) => {
            let addfile = {
                base64: `${consts.s3url}/${x?.file_path}`,
                file_path: x?.file_path,
                addtype: false,
                ext: x?.file_path.split('.')[1]
            }
            files.push(addfile);
        });
        setfiles(files);

        setjibhap(data?.jibhap);
        setviewDetailpee(false)
        setTimeout(()=>{
            setviewDetailpee(true)
        },200)
        setdetailpeeJson(data?.detailpeeJson ? JSON.parse(data?.detailpeeJson) : []);
        setissuetype(((data?.issuetype && data?.issuetype * 1 !== 0) ? JSON.parse(data?.issuetype) : []));
        setitemdesc(data?.itemdesc);
        setitem_pos_car(data?.item_pos_car);
        setclient_type(data?.client_type);
        setlisthoaddsdata(data?.hoaddsv?.split(','));
        let listfirst = [data?.building_unit];
        setlisthoaddsv(listfirst.concat(data?.hoaddsv?.split(',')));

        setlistdongv(data?.building_dong);
        setlistfloorv(data?.building_floor);
        setlisthov(data?.building_unit);
        setiskeymoney(data?.iskeymoney ? "1" : "0")

        setp_code(data?.p_code); // p_code 가 업데이트 되면 표제부랑 호출
        setlistdongv(data?.building_dong);
        setlistfloorv(data?.building_floor);
        setlisthov(data?.building_unit);

        setdongviewer(data?.dongviewer ? '1' : '0');

        setTimeout(() => {
            setlistdongProc();
        }, 200);
    }

    // 히스토리 목록 가져오기
    const loadInserHistory = () => {
        APIS.postData('/v1/item/insertHistory', {}).then(({ data }) => {
            if (data?.length > 0) {
                sethistoryList(data);
            } else {
                sethistoryList([]);
            }
        }).catch(({ response }) => {
            sethistoryList([]);
        }).finally(() => {
        });
    }

    const deleteHistory = (idx) => {
        APIS.postData('/v1/item/deleteHistory', { idx }).then(({ data }) => {
            loadInserHistory();
        }).catch(({ response }) => {
            messagePopup("해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.")
        })
    }

    return (
        <>

            <div className='ProductDetailArea' style={{ zIndex: 1003 }}>
                <div style={{ gap: 30 }}>
                    <div className='ProductDetailAreaBG'
                    // onClick={() => {
                    //     setdetailwrite(false);
                    // }}
                    />

                    <div></div>
                    <div className="ProductSendDetailpop2 ">
                        <div className="ProductpopTitle padding20" style={{ borderBottom: '1px solid #eee' }}>
                            <span>매물 상세 접수</span>
                            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                                <Button
                                    buttonTxt={`임시저장 목록 (${historyList.length})`}
                                    styles={{
                                        height: 28,
                                        padding: "0px 10px",
                                        fontSize: 14
                                    }}
                                    onPress={() => {
                                        if (historyList.length > 0) {
                                            setpopupShow(true);
                                        } else {
                                            messagePopup("임시저장 목록이 없습니다.")
                                        }
                                    }}
                                />
                                <button
                                    style={{ width: 24, height: 24 }}
                                    onClick={() => {
                                        historySaveCheck(() => {
                                            setdetailwrite(false);
                                        })
                                    }}
                                >
                                    <img src="./images/icons/x.svg" />
                                </button>
                            </div>

                        </div>
                        <div className='doubleArea'>
                            <div className="productInputarea padding32" style={{ height: wheight - 130, overflow: 'auto', borderRight: '1px solid #ddd' }}>
                                <div className='fontsize12' style={{ marginBottom: 8 }}>
                                    필수표시사항(<span className='colorF00'>*</span>)을 정확하게 입력해주세요.
                                </div>
                                <div className="inputviewtype1 ">
                                    <div>거래형태<span className='colorF00'>*</span></div>
                                    <div>
                                        {category_2 * 1 !== 3 &&
                                            <Button buttonTxt={'매매'} className={`writeRadiobutton ${sell_type === '매매' ? 'active' : ''}`} onPress={() => {
                                                setsell_type('매매')
                                                setDefaultClientType('매매')
                                                setclient_type('매도인');
                                            }} />}
                                        <Button buttonTxt={'전세'} className={`writeRadiobutton ${sell_type === '전세' ? 'active' : ''}`} onPress={() => {
                                            setsell_type('전세')
                                            setDefaultClientType('전세')
                                            setclient_type('임대인');

                                        }} />
                                        <Button buttonTxt={'월세'} className={`writeRadiobutton ${sell_type === '월세' ? 'active' : ''}`} onPress={() => {
                                            setsell_type('월세')
                                            setDefaultClientType('월세')
                                            setclient_type('임대인');
                                        }} />
                                    </div>
                                </div>
                                {category_2 * 1 === 3 &&
                                    <div className="input_error">* 단독/다가구 매매는 건물-주거전용건물 탭을 이용하세요.</div>
                                }
                                <div className="inputviewtype4 ">
                                    <div>매물 종류</div>
                                    <div>
                                        <div>
                                            {category_1_OptionConsts?.map((x, i) => {
                                                return (
                                                    <Button
                                                        key={i}
                                                        buttonTxt={x?.labels} className={`writeRadiobutton2 ${category_1 * 1 === x?.values * 1 ? 'active' : ''}`}
                                                        onPress={() => {
                                                            setcategory_1(x?.values * 1);
                                                            setcategory_2(category_2_setting?.filter((x2, i2) => (x2.category_1 * 1 === x?.values * 1))[0]?.values);
                                                            setDefaultUsage(category_2_setting?.filter((x2, i2) => (x2.category_1 * 1 === x?.values * 1))[0]?.values)

                                                            //지번처리
                                                            if ([1, 2, 3, 4, 8].includes(category_2_setting?.filter((x2, i2) => (x2.category_1 * 1 === x?.values * 1))[0]?.values)) {
                                                                setdongviewer("0")
                                                            } else {
                                                                setdongviewer("1")
                                                            }
                                                        }}
                                                    />
                                                );
                                            })}
                                        </div>
                                        <div>
                                            {category_2_setting?.filter((x, i) => x?.category_1 * 1 === category_1 * 1)?.map((x, i) => {
                                                return (
                                                    <Button
                                                        key={i}
                                                        buttonTxt={x?.labels}
                                                        className={`writeRadiobutton2 ${category_2 * 1 === x?.values * 1 ? 'active' : ''}`}
                                                        onPress={() => {
                                                            if (sell_type === '매매' && x?.values * 1 === 3) {
                                                                setsell_type('전세');
                                                                setDefaultClientType('전세')
                                                            }
                                                            setcategory_2(x?.values * 1)
                                                            setDefaultUsage(x?.values * 1)

                                                            //지번처리
                                                            if ([1, 2, 3, 4, 8].includes(x?.values * 1)) {
                                                                setdongviewer("0")
                                                            } else {
                                                                setdongviewer("1")
                                                            }
                                                        }}
                                                    />
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                                <div className='bolds margint20' style={{ height: 1 }} />
                                <div className="inputviewtype1 ">
                                    <div className='bolds ' style={{ marginTop: 2 }}>기본정보</div>
                                    <div>
                                        <Radios
                                            linetype={'radioimg'}
                                            values={jibhap}
                                            setvalues={setjibhap}
                                            namevalue={[
                                                { names: '일반건축물', values: '일반' },
                                                { names: '집합건물', values: '집합' },
                                            ]}
                                            fontweights={400}
                                            fontSizes={14}
                                            sizes={20}
                                        />
                                    </div>
                                </div>

                                <div className="inputviewtype5 " >
                                    <div>소재지<span className='colorF00'>*</span></div>
                                    <div style={{ flexDirection: 'column' }}>
                                        <div className='buttonWithTxt' style={{ marginTop: 8 }}>
                                            <div>
                                                <Button
                                                    className={'normalbutton_middle'}
                                                    buttonTxt={'주소찾기'}
                                                    onPress={() => {
                                                        setIsOpenPost(true);
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                {addrDatas?.addr}
                                            </div>
                                        </div>
                                        {isOpenPost ? (
                                            <div style={postBoxStyle}>
                                                <button type="button" className="addrbtn exit_btn" onClick={() => setIsOpenPost(false)} style={{ padding: 10 }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.79289C5.68342 5.40237 6.31658 5.40237 6.70711 5.79289L12 11.0858L17.2929 5.79289C17.6834 5.40237 18.3166 5.40237 18.7071 5.79289C19.0976 6.18342 19.0976 6.81658 18.7071 7.20711L13.4142 12.5L18.7071 17.7929C19.0976 18.1834 19.0976 18.8166 18.7071 19.2071C18.3166 19.5976 17.6834 19.5976 17.2929 19.2071L12 13.9142L6.70711 19.2071C6.31658 19.5976 5.68342 19.5976 5.29289 19.2071C4.90237 18.8166 4.90237 18.1834 5.29289 17.7929L10.5858 12.5L5.29289 7.20711C4.90237 6.81658 4.90237 6.18342 5.29289 5.79289Z" fill="#999999" />
                                                    </svg>
                                                </button>
                                                <DaumPostcode style={postCodeStyle} defaultQuery={addrDatas?.addr} autoClose onComplete={onCompletePost} />
                                            </div>
                                        ) : null}
                                        <div>
                                            <Radios
                                                linetype={'radioimg'}
                                                values={dongviewer}
                                                setvalues={(dv) => {
                                                    if (dv == '') return;
                                                    setdongviewer(dv)
                                                }}
                                                namevalue={[
                                                    { names: '지번노출', values: '0' },
                                                    { names: '지번미노출', values: '1' },
                                                ]}
                                                fontweights={400}
                                                fontSizes={14}
                                                sizes={20}
                                                disabled={[1, 2, 3, 4, 8].includes(category_2)}
                                            />
                                            {[10, 11].includes(category_2) && <p style={{ fontWeight: 700, marginTop: 10 }}>
                                                *건축법 상 단독주택은 지번을 공개하지 않아도 무관하지만, 단독주택 중 <span className='color-orange'>다가구주택 · 다중주택은 반드시 지번을 표기해야 합니다.</span>
                                            </p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="inputviewtype1 ">
                                    <div>건물(단지)명</div>
                                    <div>
                                        <Input
                                            className={`inputs`}
                                            placeholder=""
                                            setValue={settitle}
                                            value={title}
                                            name="mb_phone"
                                        />
                                    </div>
                                </div>

                                <div className="inputviewtype1 " >
                                    <div>용도<span className='colorF00'>*</span></div>
                                    <div>
                                        <div style={{ display: 'flex', gap: 10 }}>
                                            <Select
                                                styles={{
                                                    width: 200
                                                }}
                                                setValues={(e) => {
                                                    setitem_usage(e);
                                                }}
                                                values={item_usage}
                                                selectData={[
                                                    // {labels: '전체', values: ''},
                                                    { labels: '단독주택', values: '단독주택' },
                                                    { labels: '공동주택', values: '공동주택' },
                                                    { labels: '제1종 근린생활시설', values: '제1종 근린생활시설' },
                                                    { labels: '제2종 근린생활시설', values: '제2종 근린생활시설' },
                                                    { labels: '업무시설', values: '업무시설' },
                                                    { labels: '판매시설', values: '판매시설' },
                                                    { labels: '교육연구시설', values: '교육연구시설' },
                                                    { labels: '운동시설', values: '운동시설' },
                                                    { labels: '의료시설', values: '의료시설' },
                                                    { labels: '숙박시설', values: '숙박시설' },
                                                    { labels: '위락시설', values: '위락시설' },
                                                    { labels: '문화 및 집회시설', values: '문화 및 집회시설' },
                                                    { labels: '공장', values: '공장' },
                                                    { labels: '창고시설', values: '창고시설' },
                                                    { labels: '노유자시설', values: '노유자시설' },
                                                    { labels: '종교시설', values: '종교시설' },
                                                    { labels: '수련시설', values: '수련시설' },
                                                    { labels: '운수시설', values: '운수시설' },
                                                    { labels: '자동차 관련 시설', values: '자동차 관련 시설' },
                                                    { labels: '위험물 저장 및 처리 시설', values: '위험물 저장 및 처리 시설' },
                                                    { labels: '동물 및 식물 관련 시설', values: '동물 및 식물 관련 시설' },
                                                    { labels: '자원순환 관련 시설', values: '자원순환 관련 시설' },
                                                    { labels: '교정 및 군사 시설', values: '교정 및 군사 시설' },
                                                    { labels: '방송통신시설', values: '방송통신시설' },
                                                    { labels: '발전시설', values: '발전시설' },
                                                    { labels: '묘지 관련 시설', values: '묘지 관련 시설' },
                                                    { labels: '관광 휴게시설', values: '관광 휴게시설' },
                                                    { labels: '장례시설', values: '장례시설' },
                                                    { labels: '야영장 시설', values: '야영장 시설' },
                                                    { labels: '미등기건물', values: '미등기건물' },
                                                    { labels: '그 밖에 토지의 정착물', values: '그 밖에 토지의 정착물' },
                                                ]}
                                            />
                                            <div>
                                                <Button
                                                    className={'normalbutton_middle'}
                                                    buttonTxt={'용도별 건축물의 종류'}
                                                    styles={{
                                                        width: 180
                                                    }}
                                                    onPress={() => {
                                                        //setIsOpenPost(true);
                                                        window.open('https://maemul.net/images/viewpdf.pdf');
                                                        //window.open('http://43.203.243.221:4000/viewpdf.pdf');
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="inputviewtype1 ">
                                    <div>위반/미등기여부</div>
                                    <div>
                                        <Checkbox
                                            linetype={'checkimg'}
                                            values={issuetype}
                                            setvalues={(e) => {
                                                console.log(e);
                                                setissuetype(e);
                                            }}
                                            namevalue={[
                                                { names: '위반건축물', values: 0 },
                                                { names: '미등기건물', values: 1 },
                                            ]}
                                            fontweights={400}
                                            fontSizes={14}
                                            sizes={20}
                                            heightsflag={true}
                                        />
                                    </div>
                                </div>

                                <div className='bolds margint20' style={{ marginBottom: 8 }}>
                                    가격정보
                                </div>

                                {pricesinputArr?.filter((item, index) => index === 0 || index === 1)?.map((x, i) => {
                                    if (!x?.viewtype?.find((x) => x * 1 === category_2 * 1)) {
                                        return;
                                    }
                                    if (!x?.viewtype2?.find((x) => x === sell_type)) {
                                        return;
                                    }

                                    return (
                                        <div className="inputviewtype1 " key={i}>
                                            <div>{x?.titles}{x?.requireCkr === true && <span className='colorF00'>*</span>}</div>
                                            <div>
                                                <Input
                                                    type={x?.input_type}
                                                    className={`inputs`}
                                                    rightplaceholder="만원"
                                                    placeholder=""
                                                    setValue={(e) => {
                                                        setpricesinputArr(pricesinputArr?.map((x2, i2) => x2?.titles === x?.titles ? { ...x2, values: e } : x2));
                                                    }}
                                                    value={x?.values}
                                                    name={x?.titles}
                                                    zerostatus={true}
                                                    style={{
                                                        paddingRight: 40, textAlign: 'right'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    );
                                })}
                                <div className="inputviewtype3 " style={{ marginTop: 0 }} >
                                    {pricesinputArr?.filter((item, index) => index > 1 && index < 4)?.map((x, i) => {
                                        if (!x?.viewtype?.find((x) => x * 1 === category_2 * 1)) {
                                            return;
                                        }
                                        if (!x?.viewtype2?.find((x) => x === sell_type)) {
                                            return;
                                        }

                                        return (
                                            <div key={i} style={{ marginTop: 12, marginLeft: i % 2 === 1 ? 20 : 0 }}>
                                                <div>{x?.titles}{x?.requireCkr === true && <span className='colorF00'>*</span>}</div>
                                                <div>
                                                    <Input
                                                        type={x?.input_type}
                                                        className={`inputs`}
                                                        rightplaceholder="만원"
                                                        placeholder=""
                                                        setValue={(e) => {
                                                            setpricesinputArr(pricesinputArr?.map((x2, i2) => x2?.titles === x?.titles ? { ...x2, values: e } : x2));
                                                        }}
                                                        value={x?.values}
                                                        name={x?.titles}
                                                        zerostatus={true}
                                                        style={{
                                                            paddingRight: 40, textAlign: 'right'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>

                                {pricesinputArr?.filter((item, index) => index > 3 && index < 7)?.map((x, i) => {
                                    if (!x?.viewtype?.find((x) => x * 1 === category_2 * 1)) {
                                        return;
                                    }
                                    if (!x?.viewtype2?.find((x) => x === sell_type)) {
                                        return;
                                    }

                                    return (
                                        <div className="inputviewtype1 " key={i}>
                                            <div>{x?.titles}{x?.requireCkr === true && <span className='colorF00'>*</span>}</div>
                                            <div >
                                                {x?.key === 'price_keymoney' ?
                                                    <>
                                                        <Input
                                                            type={x?.input_type}
                                                            className={`inputs`}
                                                            rightplaceholder="만원"
                                                            placeholder=""
                                                            setValue={(e) => {
                                                                setpricesinputArr(pricesinputArr?.map((x2, i2) => x2?.titles === x?.titles ? { ...x2, values: e } : x2));
                                                            }}
                                                            value={x?.values}
                                                            name={x?.titles}
                                                            zerostatus={true}
                                                            style={{
                                                                paddingRight: 40, textAlign: 'right'
                                                            }}
                                                        />
                                                        <div style={{
                                                            position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 5,
                                                            marginTop: 5, width: '100%'
                                                        }}>
                                                            <Radios
                                                                linetype={'checkimg'}
                                                                values={iskeymoney}
                                                                setvalues={setiskeymoney}
                                                                namevalue={[
                                                                    { names: '권리금비공개', values: '1' },
                                                                ]}
                                                                fontweights={400}
                                                                fontSizes={14}
                                                                sizes={20}
                                                            />
                                                            <div
                                                                style={{
                                                                    backgroundColor: '#6164A5', width: 20, height: 20, borderRadius: '50%', cursor: 'pointer',
                                                                    display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff'
                                                                }}
                                                                onMouseOver={() => {
                                                                    setkeymoneycomment(true);
                                                                }}
                                                                onMouseOut={() => {
                                                                    setkeymoneycomment(false);
                                                                }}
                                                            >?</div>
                                                            {keymoneycomment === true &&
                                                                <div
                                                                    style={{
                                                                        position: 'absolute', left: 0, bottom: -65, padding: 5, borderRadius: 5,
                                                                        border: '1px solid #6164A5', background: '#fff', zIndex: 500,
                                                                        width: '100%'
                                                                    }}
                                                                >
                                                                    권리금 비공개 선택 시 미니홈·점포거래소에 “권리금 문의”로 표시되며,<br></br>
                                                                    매물 상세정보 및 고객에게 매물 전송, 공동중개 시에는 비공개 여부와 상관 없이 권리금이 표시됩니다.
                                                                </div>}
                                                        </div>
                                                    </>
                                                    :
                                                    <Input
                                                        type={x?.input_type}
                                                        className={`inputs`}
                                                        rightplaceholder={x?.titles === '관리비' ? "원" : "만원"}
                                                        placeholder=""
                                                        setValue={(e) => {
                                                            setpricesinputArr(pricesinputArr?.map((x2, i2) => x2?.titles === x?.titles ? { ...x2, values: e } : x2));
                                                        }}
                                                        value={x?.values}
                                                        name={x?.titles}
                                                        zerostatus={true}
                                                        style={{
                                                            paddingRight: 40, textAlign: 'right'
                                                        }}
                                                    />
                                                }
                                                {x?.titles === '관리비' &&
                                                    <div style={{ textAlign: 'left', width: '100%', color: 'red' }}>
                                                        *관리비는 '원' 단위로 정확하게 입력 해주세요.
                                                    </div>
                                                }
                                            </div>
  
                                        </div>
                                    );
                                })}
                                {[1, 2, 3, 4, 8, 10, 11].includes(category_2 * 1) &&
                                    <div className="inputviewtype1 " >
                                        <div>관리비<br />세부내역</div>
                                        <div style={{ borderRadius: 5, backgroundColor: '#fff', border: '1px solid #000', padding: 10 }}>
                                            {viewDetailpee && <DetailpeeComponent setdetailpeeJson={setdetailpeeJson} detailpeeJson={detailpeeJson} />}
                                        </div>
                                    </div>
                                }
                                <div className='bolds margint20' style={{ marginBottom: 8 }}>
                                    매물정보
                                </div>
                                <div
                                    style={{
                                        display: 'flex', gap: 10, justifyContent: 'space-between',
                                        flexWrap: 'wrap'
                                    }}
                                >
                                    {productinfoArr?.filter((item, index) => index < 5)?.map((x, i) => {
                                        if (!x?.viewtype?.find((x) => x * 1 === category_2 * 1)) {
                                            return;
                                        }
                                        let placeholderName = ['만원', '㎡', '동', '층', '호', '세대', '대', ''];
                                        let placeholderNameTxt = '';
                                        let rightPadding = 0;
                                        if (x?.inputstyle === '') {
                                            placeholderNameTxt = placeholderName[7];
                                        } else {
                                            placeholderNameTxt = placeholderName[x?.inputstyle * 1];
                                        }
                                        if (placeholderNameTxt === '만원' || placeholderNameTxt === '세대') {
                                            rightPadding = 40;
                                        } else if (placeholderNameTxt === '') {
                                            rightPadding = 10;
                                        } else if (placeholderNameTxt === '㎡') {
                                            rightPadding = 34;
                                        } else {
                                            rightPadding = 29;
                                        }
                                        return (
                                            <div className="inputviewtype1 " style={{ width: 'calc(50% - 10px)' }} key={i}>
                                                <div>{x?.titles}{x?.requireCkr === true && <span className='colorF00'>*</span>}</div>
                                                <div>
                                                    <Input
                                                        type={x?.input_type}
                                                        className={`inputs`}
                                                        rightplaceholder={placeholderNameTxt}
                                                        placeholder=""
                                                        setValue={(e) => {
                                                            setproductinfoArr(productinfoArr?.map((x2, i2) => x2?.titles === x?.titles ? { ...x2, values: e } : x2));
                                                        }}
                                                        value={x?.values}
                                                        name={x?.titles}
                                                        zerostatus={true}
                                                        style={{
                                                            paddingRight: rightPadding, textAlign: 'right'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                                {[1, 2, 3, 4, 5, 6, 7, 8].includes(category_2 * 1) &&
                                    <>
                                        <div
                                            style={{
                                                display: 'flex', gap: 0, justifyContent: 'space-between',
                                                flexWrap: 'wrap'
                                            }}
                                        >
                                            {/* 동, 층, 호, 해당동 총층 */}
                                            {productinfoArr?.filter((item, index) => index > 4 && index < 9)?.map((x, i) => {
                                                console.log(x);
                                                if (!x?.viewtype?.find((x) => x * 1 === category_2 * 1)) {
                                                    return;
                                                }
                                                let placeholderName = ['만원', '㎡', '동', '층', '호', '세대', '대', ''];
                                                let placeholderNameTxt = '';
                                                let rightPadding = 0;
                                                if (x?.inputstyle === '') {
                                                    placeholderNameTxt = placeholderName[7];
                                                } else {
                                                    placeholderNameTxt = placeholderName[x?.inputstyle * 1];
                                                }
                                                if (placeholderNameTxt === '만원' || placeholderNameTxt === '세대') {
                                                    rightPadding = 40;
                                                } else if (placeholderNameTxt === '') {
                                                    rightPadding = 10;
                                                } else if (placeholderNameTxt === '㎡') {
                                                    rightPadding = 34;
                                                } else {
                                                    rightPadding = 29;
                                                }
                                                // 해당동 총층
                                                if (i === 0 || i === 1 || i === 2 || i === 3) {
                                                    return (
                                                        <>
                                                            {/* {jibhap === '집합' &&
                                                                <div
                                                                    style={{
                                                                        display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '100%',
                                                                        marginTop: 8, gap: 10
                                                                    }}
                                                                >
                                                                    <div>
                                                                        {listhoaddsv?.filter((item, index) => index > 0)?.map((item, index) => item)?.join(", ")}
                                                                    </div>
                                                                    <Button
                                                                        className={'normalbutton_middle'}
                                                                        buttonTxt={'호실 추가'}
                                                                        styles={{
                                                                            width: 80, height: 30, fontSize: 12
                                                                        }}
                                                                        onPress={() => {
                                                                            setpopflag(true);
                                                                        }}
                                                                    />
                                                                </div>
                                                            } */}
                                                            <div className="inputviewtype1 " style={{ width: i === 3 ? '100%' : 'calc(33.33333333333% - 10px)' }} key={i}>
                                                                <div style={{ width: i === 3 ? 90 : 60 }}>
                                                                    {x?.titles}{x?.requireCkr === true && <span className='colorF00'>*</span>}
                                                                </div>
                                                                <div style={{ width: i === 3 ? 'calc(100% - 98px)' : '100%' }}>
                                                                    <Input
                                                                        type={x?.input_type}
                                                                        className={`inputs`}
                                                                        rightplaceholder={placeholderNameTxt}
                                                                        placeholder=""
                                                                        setValue={(e) => {
                                                                            setproductinfoArr(productinfoArr?.map((x2, i2) => x2?.titles === x?.titles ? { ...x2, values: e } : x2));
                                                                        }}
                                                                        value={x?.values}
                                                                        name={x?.titles}
                                                                        zerostatus={true}
                                                                        style={{
                                                                            paddingRight: rightPadding, textAlign: 'right'
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </>
                                                    );
                                                } else {
                                                    return (
                                                        <div className="inputviewtype1 " style={{ width: i === 3 ? '100%' : 'calc(33.33333333333% - 10px)' }} key={i}>
                                                            <div style={{ width: i === 3 ? 90 : 60 }}>
                                                                {x?.titles}{x?.requireCkr === true && <span className='colorF00'>*</span>}
                                                            </div>
                                                            <div style={{ width: i === 3 ? 'calc(100% - 98px)' : '100%' }}>
                                                                {(i === 2 && jibhap === '일반') ?
                                                                    <Input
                                                                        type={x?.input_type}
                                                                        className={`inputs`}
                                                                        rightplaceholder={placeholderNameTxt}
                                                                        placeholder=""
                                                                        setValue={(e) => {
                                                                            setproductinfoArr(productinfoArr?.map((x2, i2) => x2?.titles === x?.titles ? { ...x2, values: e } : x2));
                                                                        }}
                                                                        value={x?.values}
                                                                        name={x?.titles}
                                                                        zerostatus={true}
                                                                        style={{
                                                                            paddingRight: rightPadding, textAlign: 'right'
                                                                        }}
                                                                    />
                                                                    :
                                                                    (() => {
                                                                        if (i === 0 && plistdong.length <= 0) {
                                                                            return <div style={{
                                                                                display: "flex", alignItems: "center",
                                                                                width: "100%",
                                                                                height: 40,
                                                                                padding: "0px 20px",
                                                                                borderRadius: 4,
                                                                                border: "1px solid #DDD"
                                                                            }}>동명칭 없음</div>;
                                                                        }
                                                                        return <Select
                                                                            styles={{}}
                                                                            setValues={(e) => {
                                                                                setproductinfoArr(productinfoArr?.map((x2, i2) => x2?.titles === x?.titles ? { ...x2, values: e } : x2));
                                                                                if (i === 1) {
                                                                                    setlisthov('');
                                                                                    setlistfloorv(e);
                                                                                } else if (i === 2) {
                                                                                    console.log('eeeeee', e);
                                                                                    setlisthov(e);
                                                                                    setlisthoaddsv([e]);
                                                                                } else {
                                                                                    setlistfloorv('');
                                                                                    setlisthov('');
                                                                                    setlistdongv(e);
                                                                                }
                                                                            }}
                                                                            values={x?.values}
                                                                            selectData={
                                                                                i === 0 ?
                                                                                    plistdong
                                                                                    :
                                                                                    i === 1 ? plistfloor : plistho
                                                                            }
                                                                            subselectClass={'fontsize12'}
                                                                        />
                                                                    })()}
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                            })}
                                        </div>
                                        <div>
                                        </div>
                                    </>
                                }
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].includes(category_2 * 1) &&
                                    <>
                                        <div
                                            style={{
                                                display: 'flex', gap: 10, justifyContent: 'space-between',
                                                flexWrap: 'wrap'
                                            }}
                                        >
                                            {productinfoArr?.filter((item, index) => index > 13 && index < 16)?.map((x, i) => {
                                                if (!x?.viewtype?.find((x) => x * 1 === category_2 * 1)) {
                                                    return;
                                                }
                                                let placeholderName = ['만원', '㎡', '동', '층', '호', '세대', '대', ''];
                                                let placeholderNameTxt = '';
                                                let rightPadding = 0;
                                                if (x?.inputstyle === '') {
                                                    placeholderNameTxt = placeholderName[7];
                                                } else {
                                                    placeholderNameTxt = placeholderName[x?.inputstyle * 1];
                                                }
                                                if (placeholderNameTxt === '만원' || placeholderNameTxt === '세대') {
                                                    rightPadding = 40;
                                                } else if (placeholderNameTxt === '') {
                                                    rightPadding = 10;
                                                } else if (placeholderNameTxt === '㎡') {
                                                    rightPadding = 34;
                                                } else {
                                                    rightPadding = 29;
                                                }
                                                return (
                                                    <>
                                                        <div className="inputviewtype1 " style={{ width: 'calc(50% - 10px)' }} key={i}>
                                                            <div>{x?.titles}{x?.requireCkr === true && <span className='colorF00'>*</span>}</div>
                                                            <div>
                                                                {x?.key === 'item_direction' &&
                                                                    <Select
                                                                        styles={{}}
                                                                        setValues={(e) => {
                                                                            setproductinfoArr(productinfoArr?.map((x2, i2) => x2?.titles === x?.titles ? { ...x2, values: e } : x2));
                                                                        }}
                                                                        values={x?.values}
                                                                        selectData={[
                                                                            { labels: '선택', values: '' },
                                                                            { labels: '동', values: '동' },
                                                                            { labels: '서', values: '서' },
                                                                            { labels: '남', values: '남' },
                                                                            { labels: '북', values: '북' },
                                                                            { labels: '남동', values: '남동' },
                                                                            { labels: '남서', values: '남서' },
                                                                            { labels: '북동', values: '북동' },
                                                                            { labels: '북서', values: '북서' }
                                                                        ]}
                                                                        subselectClass={'fontsize12'}
                                                                    />
                                                                }
                                                                {x?.key === 'item_direction_standard' &&
                                                                    <Select
                                                                        styles={{}}
                                                                        setValues={(e) => {
                                                                            setproductinfoArr(productinfoArr?.map((x2, i2) => x2?.titles === x?.titles ? { ...x2, values: e } : x2));
                                                                        }}
                                                                        values={x?.values}
                                                                        selectData={[
                                                                            { labels: '선택', values: '' },
                                                                            { labels: '주된 출입구', values: '주된 출입구' },
                                                                            { labels: '거실', values: '거실' },
                                                                            { labels: '안방', values: '안방' },
                                                                        ]}
                                                                        subselectClass={'fontsize12'}
                                                                    />
                                                                }
                                                            </div>
                                                        </div>

                                                    </>
                                                );
                                            })}
                                        </div>
                                        <div
                                            style={{
                                                display: 'flex', gap: 10, justifyContent: 'space-between',
                                                flexWrap: 'wrap'
                                            }}
                                        >
                                            <div className="inputviewtype1 " style={{ width: 'calc(100% - 0px)' }}>
                                                <div></div>
                                                <div>
                                                    <div style={{ width: '100%', height: 300, position: 'relative', background: '#ddd' }}>
                                                        <div style={{
                                                            position: 'absolute', top: 5, backgroundColor: '#361C87', borderRadius: 5, width: 20, height: 20,
                                                            color: '#fff', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                            left: 'calc(50% - 10px)', zIndex: 1000
                                                        }}>
                                                            북
                                                        </div>
                                                        <div style={{
                                                            position: 'absolute', bottom: 5, backgroundColor: '#361C87', borderRadius: 5, width: 20, height: 20,
                                                            color: '#fff', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                            left: 'calc(50% - 10px)', zIndex: 1000
                                                        }}>
                                                            남
                                                        </div>
                                                        <div style={{
                                                            position: 'absolute', top: 'calc(50% - 10px)', backgroundColor: '#361C87', borderRadius: 5, width: 20, height: 20,
                                                            color: '#fff', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                            left: 5, zIndex: 1000
                                                        }}>
                                                            서
                                                        </div>
                                                        <div style={{
                                                            position: 'absolute', top: 'calc(50% - 10px)', backgroundColor: '#361C87', borderRadius: 5, width: 20, height: 20,
                                                            color: '#fff', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                            right: 5, zIndex: 1000
                                                        }}>
                                                            동
                                                        </div>
                                                        <Map // 지도를 표시할 Container
                                                            id="map"
                                                            center={latlng}
                                                            style={{
                                                                // 지도의 크기
                                                                width: "100%",
                                                                height: "100%",
                                                            }}
                                                            level={3} // 지도의 확대 레벨
                                                        >
                                                            <MapMarker // 마커를 생성합니다
                                                                position={latlng}
                                                                image={{
                                                                    src: "./images/icons/map-marker-svgrepo-com.svg", // 마커이미지의 주소입니다
                                                                    size: {
                                                                        width: 24,
                                                                        height: 24,
                                                                    }, // 마커이미지의 크기입니다
                                                                    options: {
                                                                        offset: {
                                                                            x: 12,
                                                                            y: 24,
                                                                        }, // 마커이미지의 옵션입니다. 마커의 좌표와 일치시킬 이미지 안에서의 좌표를 설정합니다.
                                                                    },
                                                                }}
                                                            />
                                                        </Map>
                                                    </div>
                                                    <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 5 }}>
                                                        <Button
                                                            className={'normalbutton_middle'}
                                                            buttonTxt={'지도 크게 보기'}
                                                            styles={{
                                                                width: 120, height: 30, fontSize: 12
                                                            }}
                                                            onPress={() => {
                                                                window.open(`https://map.kakao.com/link/map/${addrDatas?.addr},${latlng?.lat},${latlng?.lng}`);
                                                                //setpopflag(true);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }

                                <div
                                    style={{
                                        display: 'flex', gap: 0, justifyContent: 'space-between',
                                        flexWrap: 'wrap'
                                    }}
                                >
                                    {productinfoArr?.filter((item, index) => index > 8 && index !== 14 && index !== 15)?.map((x, i) => {
                                        if (!x?.viewtype?.find((x) => x * 1 === category_2 * 1)) {
                                            return;
                                        }
                                        let placeholderName = ['만원', '㎡', '동', '층', '호', '세대', '대', ''];
                                        let placeholderNameTxt = '';
                                        let rightPadding = 0;
                                        if (x?.inputstyle === '') {
                                            placeholderNameTxt = placeholderName[7];
                                        } else {
                                            placeholderNameTxt = placeholderName[x?.inputstyle * 1];
                                        }
                                        if (placeholderNameTxt === '만원' || placeholderNameTxt === '세대') {
                                            rightPadding = 40;
                                        } else if (placeholderNameTxt === '') {
                                            rightPadding = 10;
                                        } else if (placeholderNameTxt === '㎡') {
                                            rightPadding = 34;
                                        } else {
                                            rightPadding = 29;
                                        }
                                        let requireDisable = true;
                                        if (x?.key === "item_room") {
                                            requireDisable = [5, 6, 7, 9].includes(category_2 * 1) ? false : true
                                        }
                                        return (
                                            <div className="inputviewtype1 " style={{ width: 'calc(50% - 10px)' }} key={i}>
                                                <div>{x?.titles}{(x?.requireCkr === true && requireDisable) && <span className='colorF00'>*</span>}</div>
                                                <div>
                                                    <Input
                                                        type={x?.input_type}
                                                        className={`inputs`}
                                                        rightplaceholder={placeholderNameTxt}
                                                        placeholder=""
                                                        setValue={(e) => {
                                                            setproductinfoArr(productinfoArr?.map((x2, i2) => x2?.titles === x?.titles ? { ...x2, values: e } : x2));
                                                        }}
                                                        value={x?.values}
                                                        name={x?.titles}
                                                        zerostatus={true}
                                                        style={{
                                                            paddingRight: rightPadding, textAlign: 'right'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className="inputviewtype1 ">
                                    <div>주차 가능 대수</div>
                                    <div>
                                        <Input
                                            className={`inputs`}
                                            rightplaceholder={'대'}
                                            maxlength={10}
                                            setValue={setitem_pos_car}
                                            onBlur={() => {

                                            }}
                                            value={item_pos_car}
                                            name="mb_phone"
                                            style={{
                                                paddingRight: 29, textAlign: 'right'
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="inputviewtype1 ">
                                    <div>건축물 일자<span className='colorF00'>*</span></div>
                                    <div>
                                        <Input
                                            className={`inputs`}
                                            placeholder="yyyy-mm-dd"
                                            maxlength={10}
                                            setValue={setitem_date}
                                            onBlur={() => {
                                                console.log(item_date);
                                                if (moment(item_date).format('YYYY-MM-DD') === 'Invalid date') {
                                                    setdateerrmsg('날짜를 확인해주세요.');
                                                } else if (item_date?.length < 8) {
                                                    setdateerrmsg('8자리 숫자로 입력해주세요.');
                                                } else {
                                                    if (moment() >= moment(item_date)) {
                                                        setitem_date(moment(item_date).format('YYYY-MM-DD'));
                                                    } else {
                                                        setdateerrmsg('날짜를 확인해주세요.');
                                                    }
                                                }
                                            }}
                                            value={item_date}
                                            name="mb_phone"
                                            style={{
                                                textAlign: 'right'
                                            }}
                                            error={dateerrmsg}
                                        />
                                    </div>
                                </div>
                                <div className="inputviewtype1 ">
                                    <div></div>
                                    <div>
                                        <Radios
                                            linetype={'radioimg'}
                                            values={item_date_type}
                                            setvalues={setitem_date_type}
                                            namevalue={[
                                                { names: '사용승인일', values: '사용승인일' },
                                                { names: '사용검사일', values: '사용검사일' },
                                                { names: '준공인가일', values: '준공인가일' },
                                            ]}
                                            fontweights={400}
                                            fontSizes={14}
                                            sizes={20}
                                        />
                                    </div>
                                </div>

                                <div className="inputviewtype1 ">
                                    <div>입주가능일<span className='colorF00'>*</span></div>
                                    <div
                                        style={{ gap: 10 }}
                                    >
                                        <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
                                            <Button
                                                styles={{ height: 30, borderRadius: "10px 0px 0px 10px" }}
                                                buttonTxt={'즉시 입주'} className={`writeRadiobutton ${item_move_date.indexOf('즉시') >= 0 ? 'active' : ''}`} onPress={() => {
                                                    setdateerrmsg2('');
                                                    setitem_move_date('즉시 입주');
                                                }} />
                                            <Button
                                                styles={{ marginRight: 10, height: 30, borderRadius: "0px 10px 10px 0px" }}
                                                buttonTxt={'입주일 입력'} className={`writeRadiobutton ${(item_move_date.indexOf('즉시') < 0) ? 'active' : ''}`} onPress={() => {
                                                    setdateerrmsg2('');
                                                    setitem_move_date('');
                                                }} />
                                            <Radios
                                                linetype={'checkimg'}
                                                values={item_move_type}
                                                setvalues={(e) => {
                                                    setdateerrmsg2('');
                                                    setitem_move_type(e);
                                                }}
                                                namevalue={[
                                                    { names: '협의 가능', values: '협의 가능' },
                                                ]}
                                                fontweights={400}
                                                fontSizes={14}
                                                sizes={20}
                                            />
                                        </div>

                                        <div style={{
                                            display: "flex",
                                            width: "100%",
                                            justifyContent: 'space-between',
                                            alignItems: 'center'
                                        }}>
                                            <div style={{ width: 'calc(100% - 127px)' }}>
                                                <Input
                                                    className={`inputs`}
                                                    placeholder="yyyy-mm-dd"
                                                    maxlength={10}
                                                    setValue={setitem_move_date}
                                                    valid={"num"}
                                                    onBlur={() => {
                                                        console.log(item_move_date);
                                                        if (moment(item_move_date).format('YYYY-MM-DD') === 'Invalid date') {
                                                            setdateerrmsg2('날짜를 확인해주세요.');
                                                        } else {
                                                            setdateerrmsg2(''); // 날짜 에러 텍스트 삭제
                                                            setitem_move_date(moment(item_move_date).format('YYYY-MM-DD'));
                                                        }
                                                    }}
                                                    value={item_move_date}
                                                    name="mb_phone"
                                                    style={{
                                                        textAlign: 'right'
                                                    }}
                                                    error={dateerrmsg2}
                                                    disableds={item_move_date === '즉시 입주' ? true : false}
                                                />
                                            </div>
                                            {/* <div style={{ width: 120, display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                                                <Radios
                                                    linetype={'checkimg'}
                                                    values={item_move_type}
                                                    setvalues={(e) => {
                                                        setdateerrmsg2('');
                                                        setitem_move_date(e === '하시' ? '즉시입주' : '협의가능');
                                                        setitem_move_type(e);
                                                    }}
                                                    namevalue={[
                                                        {names: '하시', values: '하시'},
                                                        {names: '협의', values: '협의'},
                                                    ]}
                                                    fontweights={400}
                                                    fontSizes={14}
                                                    sizes={20}
                                                />                                       
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="inputviewtype1 ">
                                    <div>의뢰인</div>
                                    <div
                                        style={{
                                            display: 'flex', flexDirection: 'row', gap: 10,
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        <div style={{ width: 100 }}>
                                            <Select
                                                styles={{}}
                                                setValues={(e) => {
                                                    setclient_type(e);
                                                }}
                                                values={client_type}
                                                selectData={[
                                                    { labels: '매도인', values: '매도인' },
                                                    { labels: '임대인', values: '임대인' },
                                                    { labels: '현임차인', values: '현임차인' },
                                                    { labels: '대리인', values: '대리인' },
                                                    { labels: '관리인', values: '관리인' },
                                                    { labels: '부동산', values: '부동산' },
                                                ]}
                                                subselectClass={'fontsize12'}
                                            />
                                        </div>
                                        <div style={{ width: 'calc(100% - 110px)' }}>
                                            <Input
                                                className={`inputs`}
                                                placeholder=""
                                                setValue={setclient_name}
                                                value={client_name}
                                                name="mb_phone"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="inputviewtype1 ">
                                    <div>연락처<span className='colorF00'>*</span></div>
                                    <div>
                                        <Input
                                            className={`inputs`}
                                            placeholder=""
                                            setValue={setclient_hp}
                                            value={client_hp}
                                            name="customerhp"
                                        />
                                    </div>
                                </div>

                                <div className="inputviewtype1 ">
                                    <div>특이사항</div>
                                    <div>
                                        <textarea
                                            placeholder='추후 상세등록 시 필요한 사항들을 작성하시면 매물관리에 도움이 됩니다.ex) 방/욕실 수, 공실여부, 현업종, 상호 등'
                                            onChange={(e) => {
                                                setdesc(e.target.value);
                                            }}
                                            value={desc}
                                        />
                                    </div>
                                </div>

                                <div className="inputviewtype1 ">
                                    <div>매물 소개</div>
                                    <div>
                                        <textarea
                                            placeholder=''
                                            onChange={(e) => {
                                                setitemdesc(e.target.value);
                                            }}
                                            value={itemdesc}
                                        />
                                    </div>
                                </div>

                                <input type='file' ref={selectFile} style={{ display: 'none' }} multiple={true} onChange={(e) => {
                                    let file = e.target.files[0];

                                    let filesData = e.target.files;
                                    var arr = Array.prototype.slice.call(filesData);
                                    let addFiles = [];
                                    function test(urls) {
                                        console.log(urls);
                                        addFiles.push(urls);
                                    }
                                    function preview(arr) {
                                        for (let t = 0; t < arr?.length; t++) {
                                            let savecount = files?.length;
                                            if (t + savecount > 19) {
                                                continue;
                                            }
                                            if (arr[t].type.match('image.*')) {

                                                arr[t].base64 = URL.createObjectURL(arr[t]);
                                                arr[t].ext = arr[t]?.name.split('.')[1];
                                                arr[t].addtype = true;

                                                addFiles.push(arr[t]);
                                                // var reader = new FileReader();
                                                // var test = reader.onload = async (e) => {
                                                //     let resizebase64 = await resizedataURL(e.target.result,500,500);
                                                //     arr[t].base64 = resizebase64;
                                                //     arr[t].ext = filesData[t]?.name.split('.')[1];
                                                //     arr[t].addtype = true;
                                                //     return arr[t];
                                                // }
                                                // console.log(test);
                                            }
                                        }
                                        setfiles(files.concat(addFiles));
                                    }
                                    preview(arr);
                                }} />

                                <div className="inputviewtype1 ">
                                    <div>사진</div>
                                    <div>
                                        <div className="write_image_list" style={{ flexWrap: 'wrap' }}>
                                            {files?.length < 20 &&
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        selectFile.current.click();
                                                    }}
                                                >
                                                    <p>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <path d="M14.1053 13C14.1053 14.1579 13.1579 15.1053 12 15.1053C10.8421 15.1053 9.89474 14.1579 9.89474 13C9.89474 11.8421 10.8421 10.8947 12 10.8947C13.1579 10.8947 14.1053 11.8421 14.1053 13ZM22 10.8947V16.1579C22 18.7632 19.8684 20.8947 17.2632 20.8947H6.73684C4.13158 20.8947 2 18.7632 2 16.1579V10.8947C2 8.36842 3.97368 6.31579 6.44737 6.15789L7.76316 4.15789C8.26316 3.42105 9.07895 3 9.94737 3H14C14.8947 3 15.6842 3.44737 16.1842 4.15789L17.5 6.15789C20.0263 6.31579 22 8.36842 22 10.8947ZM16.2105 13C16.2105 10.6842 14.3158 8.78947 12 8.78947C9.68421 8.78947 7.78947 10.6842 7.78947 13C7.78947 15.3158 9.68421 17.2105 12 17.2105C14.3158 17.2105 16.2105 15.3158 16.2105 13ZM19.3684 9.84211C19.3684 9.26316 18.8947 8.78947 18.3158 8.78947C17.7368 8.78947 17.2632 9.26316 17.2632 9.84211C17.2632 10.4211 17.7368 10.8947 18.3158 10.8947C18.8947 10.8947 19.3684 10.4211 19.3684 9.84211Z" fill="#6164A5" />
                                                        </svg>
                                                    </p>
                                                    <p>업로드</p>
                                                    <p>{files?.length}<span className='color999'>/20</span></p>
                                                </button>
                                            }

                                            {files?.map((x, i) => {
                                                return (
                                                    <div key={i} style={{ backgroundImage: `url(${x?.base64})` }}>
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                seterrmsg('');
                                                                // let deletefiles = {
                                                                //     base64: files?.filter((x2, i2) => i2 === i)[0]?.file_path,
                                                                //     ext: files?.filter((x2, i2) => i2 === i)[0]?.ext
                                                                // }
                                                                setdelete_files([...delete_files, files?.filter((x2, i2) => i2 === i)[0]?.file_path]);
                                                                //addFiles = files?.filter((x2, i2) => i2 !== i);
                                                                setfiles(files?.filter((x2, i2) => i2 !== i));
                                                            }}
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                                                <rect x="0.333984" width="16" height="16" rx="4" fill="#101010" />
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M5.5683 5.23431C5.88072 4.9219 6.38725 4.9219 6.69967 5.23431L8.53398 7.06863L10.3683 5.23431C10.6807 4.9219 11.1873 4.9219 11.4997 5.23431C11.8121 5.54673 11.8121 6.05327 11.4997 6.36569L9.66536 8.2L11.4997 10.0343C11.8121 10.3467 11.8121 10.8533 11.4997 11.1657C11.1873 11.4781 10.6807 11.4781 10.3683 11.1657L8.53398 9.33137L6.69967 11.1657C6.38725 11.4781 5.88072 11.4781 5.5683 11.1657C5.25588 10.8533 5.25588 10.3467 5.5683 10.0343L7.40261 8.2L5.5683 6.36569C5.25588 6.05327 5.25588 5.54673 5.5683 5.23431Z" fill="white" />
                                                            </svg>
                                                        </button>
                                                    </div>
                                                );
                                            })}

                                        </div>
                                    </div>
                                </div>

                                <div
                                    style={{ height: 1, backgroundColor: '#EEE', marginTop: 20 }}
                                />
                                <div className="input_error">{errmsg}</div>
                                <div
                                    className='margint20'
                                    style={{
                                        display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8
                                    }}
                                >
                                    <div style={{ width: '50%' }}>
                                        <Button
                                            buttonTxt={'취소'}
                                            disabled={true}
                                            onPress={() => {
                                                historySaveCheck(() => {
                                                    setdetailwrite(false);
                                                })
                                            }}
                                        />
                                    </div>
                                    <div style={{ width: '50%' }}>
                                        <Button
                                            buttonTxt={'등록'}
                                            styles={{
                                            }}
                                            onPress={() => {
                                                let rechangefiles = files?.map((x, i) => {
                                                    if (x?.addtype === true) {
                                                        //let test = readFile(x?.filedata);
                                                        resizedataURL(x?.base64, 500, 500).then((data) => {
                                                            x.base = data;
                                                        });
                                                        return x;
                                                    } else {
                                                        return x;
                                                    }
                                                });
                                                //console.log(rechangefiles);
                                                setfiles(rechangefiles);
                                                setTimeout(() => {
                                                    simpleWirteSubmit(uidx, false);
                                                }, 200);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            {p_code !== '' ?
                                <div
                                    style={{
                                        display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column', gap: 8,
                                        height: wheight - 130, overflow: 'auto'
                                    }}
                                >
                                    {pcodeDatas['총괄표제부']?.filter((item, index) => index === list1Viewer).map((x, i) => {
                                        return (
                                            <InfoViewlists
                                                p_code={p_code}
                                                titles={'총괄표제부'}
                                                rightButtons={pcodeDatas['총괄표제부']?.length > 1 ? true : false}
                                                rightButtonsCount={pcodeDatas['총괄표제부']}
                                                setrightButtons={setlist1Viewer}
                                                lists={[
                                                    { viewnames: '건물명', values: x['건물명'] || '-' },
                                                    { viewnames: '용도', values: x['기타용도'] || '-' },
                                                    { viewnames: '대지면적', values: x['대지면적'] + '㎡' || '-' },
                                                    { viewnames: '건축면적', values: x['건축면적'] + '㎡' || '-' },
                                                    { viewnames: '연면적', values: x['연면적'] + '㎡' || '-' },
                                                    { viewnames: '건폐율', values: x['건폐율'] || '-' },
                                                    { viewnames: '용적률', values: x['용적률'] || '-' },
                                                    { viewnames: '세대/가구/호', values: `${x['세대수']}/${x['가구수']}/${x['호수']}` },
                                                    { viewnames: '외필지수', values: x['외필지수'] || '-' },
                                                    { viewnames: '기계식 주차', values: `${((x['옥내기계식대수'] * 1) + (x['옥외기계식대수'] * 1))}` },
                                                    { viewnames: '자주식 주차', values: `${((x['옥내자주식대수'] * 1) + (x['옥외자주식대수'] * 1))}` },
                                                    { viewnames: '승강기(승용)', values: x['승용승강기수'] || '-' },
                                                    { viewnames: '승강기(비상)', values: x['비상용승강기수'] || '-' },
                                                    { viewnames: '승강기 총합', values: anySumFunc(x['승용승강기수'], x['비상용승강기수']) },
                                                    { viewnames: '사용승인일', values: moment(x['사용승인일']).isValid() ? moment(x['사용승인일']).format('YYYY-MM-DD') : '-' },
                                                ]}
                                            />
                                        );
                                    })}
                                    {pcodeDatas['표제부']?.filter((item, index) => index === list2Viewer).map((x, i) => {

                                        return (
                                            <InfoViewlists
                                                p_code={p_code}
                                                titles={'표제부'}
                                                rightButtons={pcodeDatas['표제부']?.length > 1 ? true : false}
                                                rightButtonsCount={pcodeDatas['표제부']}
                                                setrightButtons={setlist2Viewer}
                                                setlistdongNames={setlistdongNames}
                                                setproductinfoArr={setproductinfoArr}
                                                floorDatas={x['지상층수']}
                                                lists={[
                                                    { viewnames: '건물명', values: x['건물명'] || '-' },
                                                    { viewnames: '동', values: x['동명'] || '-' },
                                                    { viewnames: '주용도', values: x['기타용도'] || '-' },
                                                    { viewnames: '주구조', values: x['기타구조'] || '-' },
                                                    { viewnames: '층수(지상/지하)', values: `${x['지상층수']}/${x['지하층수']}` },
                                                    { viewnames: '대지면적', values: x['대지면적'] + '㎡' || '-' },
                                                    { viewnames: '건축면적', values: x['건축면적'] + '㎡' || '-' },
                                                    { viewnames: '연면적', values: x['연면적'] + '㎡' || '-' },
                                                    { viewnames: '건폐율', values: x['건폐율'] || '-' },
                                                    { viewnames: '용적률', values: x['용적률'] || '-' },
                                                    { viewnames: '세대/가구/호', values: `${x['세대수']}/${x['가구수']}/${x['호수']}` },
                                                    { viewnames: '외필지수', values: x['외필지수'] || '-' },
                                                    { viewnames: '기계식 주차', values: `${((x['옥내기계식대수'] * 1) + (x['옥외기계식대수'] * 1))}` },
                                                    { viewnames: '자주식 주차', values: `${((x['옥내자주식대수'] * 1) + (x['옥외자주식대수'] * 1))}` },
                                                    { viewnames: '승강기(승용)', values: x['승용승강기수'] || '-' },
                                                    { viewnames: '승강기(비상)', values: x['비상용승강기수'] || '-' },
                                                    { viewnames: '승강기 총합', values: anySumFunc(x['승용승강기수'], x['비상용승강기수']) },
                                                    { viewnames: '사용승인일', values: moment(x['사용승인일']).isValid() ? moment(x['사용승인일']).format('YYYY-MM-DD') : '-' },
                                                ]}
                                            />
                                        );
                                    })}
                                    {pcodeDatas['표제부']?.find((item, index) => index === list2Viewer)?.['대장종류코드명'] === '일반건축물' &&
                                        <InfoViewlists
                                            p_code={p_code}
                                            titles={'층별개요'}
                                            listdongNames={listdongNames}
                                            lists={listdongNames ? pcodeDatas['층별개요']?.filter(item => {
                                                if (listdongNames === "동명칭 없음") {
                                                    return item['동명'] === ""
                                                }
                                                return item['동명'] === listdongNames
                                            }).map((x, i) => {
                                                x.viewnames = `${x['층구분코드명']} ${x['층번호']}층`;
                                                x.values = x['기타용도'];
                                                x.values1 = `${x['면적']}㎡`;
                                                return x;
                                            }) : pcodeDatas['층별개요']?.map((x, i) => {
                                                x.viewnames = `${x['층구분코드명']} ${x['층번호']}층`;
                                                x.values = x['기타용도'];
                                                x.values1 = `${x['면적']}㎡`;
                                                return x;
                                            })}
                                        />
                                    }
                                    {pcodeDatas['표제부']?.find((item, index) => index === list2Viewer)?.['대장종류코드명'] === '표제부' &&
                                        <InfoViewlists
                                            styles={'infoviewstyle2'}
                                            titles={'호실정보'}
                                            liststyle2arr={pcodeDatas['전유공용']}
                                            lists={[
                                                { viewnames: '전유', values: '3층', values1: '제1종근린시설', values2: '(치과의원)', values3: '1,383.19 ㎡' },
                                                { viewnames: '공용', values: '지1층', values1: '게계실, 발전기실, 전기실', values2: '', values3: '1.05 ㎡' },
                                                { viewnames: '공용', values: '3층', values1: '복도, 화장실, 계단실, 엘리베이터', values2: '', values3: '30.96 ㎡' },
                                                { viewnames: '공용', values: '틍각층', values1: '주차장', values2: '(지하1층, 1층)', values3: '48.86 ㎡' },
                                            ]}
                                            setplistdong={setplistdong}
                                            setplistfloor={setplistfloor}
                                            setplistho={setplistho}
                                        />
                                    }

                                    {/* {pcodeDatas['토지이용계획']?.map((x, i) => {
                                    //console.log(pcodeDatas['토지이용계획']);
                                    //console.log(pcodeDatas['토지임야정보']);
                                })} */}
                                    {pcodeDatas['토지이용계획']?.length > 0 &&
                                        <InfoViewlists
                                            titles={'토지이용계획(본)'}
                                            styles={'infoviewstyle3'}
                                            lists={{
                                                title: pcodeDatas['토지임야정보'],
                                                sublists: pcodeDatas['토지이용계획'],
                                            }}
                                        />
                                    }
                                    {pcodesubDatas?.length > 0 && pcodesubDatas?.map((x, i) => {
                                        //console.log("!!!!!!!!!!", x['토지임야정보']?.length);
                                        if (x['토지임야정보']?.length > 0) {
                                            return (
                                                <InfoViewlists
                                                    titles={'토지이용계획(부)'}
                                                    styles={'infoviewstyle3'}
                                                    lists={{
                                                        title: x['토지임야정보'],
                                                        sublists: x['토지이용계획'],
                                                    }}
                                                />
                                            );
                                        }
                                    })}
                                </div>
                                :
                                <div>
                                    <div className='nolistArea'>
                                        소재지를 검색해주세요.
                                    </div>
                                </div>}
                        </div>
                    </div>
                    <div></div>
                </div>
            </div>
            {popflag === true &&
                <div className='PopupArea'>
                    <div>
                        <div className='PopupAreaBG'
                        //onClick={() => { setpopflag(false); }}
                        />
                        <div className='PopupAreaContents'>
                            <div>
                                <div className="popTitle padding20">
                                    <span >호실추가</span>
                                    <button
                                        onClick={() => {
                                            setpopflag(false);
                                        }}
                                    >
                                        <img src="./images/icons/x.svg" width='20' />
                                    </button>
                                </div>
                                <div className="padding32">
                                    <div className='popcontents'>
                                        <div style={{ width: '100%' }}>
                                            {listhoaddsdata?.map((x, i) => {
                                                return (
                                                    <div style={{ marginTop: i > 0 ? 8 : 0 }}>
                                                        <Select
                                                            setValues={(e) => {
                                                                // const [listhov, setlisthov] = useState('');   
                                                                // listhoaddsv
                                                                if (listhoaddsv?.includes(e)) {
                                                                    let lists = listhoaddsdata?.map((item, index) => index === i ? '' : item);
                                                                    setlisthoaddsdata(listhoaddsdata?.map((item, index) => index === i ? '' : item));
                                                                } else {
                                                                    setlisthoaddsdata(listhoaddsdata?.map((item, index) => index === i ? e : item));
                                                                }
                                                                let concatfirst = listhoaddsv?.filter((item, index) => index === 0);
                                                                setlisthoaddsv(concatfirst?.concat(listhoaddsdata?.map((item, index) => index === i ? e : item)));
                                                            }}
                                                            values={x}
                                                            selectData={[
                                                                { labels: '선택하세요.', values: '' },
                                                                ...plistho?.filter(item => !listhoaddsv?.includes(item?.values)),
                                                                x !== '' && { labels: x, values: x },
                                                            ]}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>

                                    </div>
                                    <div className='margint8'>
                                        <button
                                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}
                                            onClick={() => {
                                                let addArr = [''];
                                                console.log(listhoaddsdata);

                                                if ((plistho?.length - 1) <= listhoaddsdata?.length) {
                                                    return;
                                                }
                                                setlisthoaddsdata(listhoaddsdata.concat(addArr));
                                            }}
                                        >
                                            <img src="./images/icons/addplus.svg" width='30' />
                                        </button>
                                    </div>
                                    <div className='popbuttons'>
                                        <div>
                                            <Button
                                                disabled={true}
                                                buttonTxt={'아니오'}
                                                onPress={() => { setpopflag(false); }}
                                            />
                                        </div>
                                        <div>
                                            <Button
                                                buttonTxt={'적용하기'}
                                                onPress={() => {
                                                    //let concatfirst = listhoaddsv?.filter((item, index) => index === 0);
                                                    //setlisthoaddsv(concatfirst?.concat(listhoaddsdata));
                                                    setpopflag(false);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>}
            {popupShow && <div className='PopupArea' >
                <div>
                    <div className='PopupAreaBG'
                    //onClick={() => dispatch(close())}
                    />
                    <div className='PopupAreaContents' style={{ width: 700 }}>
                        <div>
                            <div className="popTitle padding20">
                                <span >{"임시저장 목록"}</span>
                                <button
                                    onClick={() => {
                                        setpopupShow(false)
                                    }}
                                >
                                    <img src="./images/icons/x.svg" width='20' />
                                </button>
                            </div>

                            <div className="padding20">
                                <div className='main_popup_list_container'>
                                    <p className='color-orange'><b>임시저장은 최대 1주일간 보관됩니다. 이후 자동삭제 되며 및 복구가 불가능합니다.</b></p>
                                    <div style={{ width: 660, marginTop: 10 }}>
                                        <div className='main_popup_list_index'>
                                            <p className='p_4'>임시저장일</p>
                                            <p className='p_4'>주소</p>
                                            <p className='p_4'>연락처</p>
                                            <p className='p_4' style={{ borderRight: 0 }}>-</p>
                                        </div>

                                        <div className='main_popup_list_data_box'>
                                            {historyList?.map((x, i) => {
                                                return (
                                                    <div key={i} className='main_popup_list_data'>
                                                        <p className='p_4'>{moment(x?.create_dt).format("YYYY-MM-DD HH:mm")}</p>
                                                        <p className='p_4 ellipsis'>{x?.addr}</p>
                                                        <p className='p_4'>{x?.client_hp ? hpHypen(x?.client_hp) : "-"}</p>
                                                        <p className='p_4' style={{ display: "flex", gap: 10, alignItems: "center" }}>
                                                            <Button
                                                                buttonTxt={"불러오기"}
                                                                onPress={() => {
                                                                    importHistory(x)
                                                                    setpopupShow(false)
                                                                }}
                                                                styles={{ width: 150, height: 30, fontSize: 14 }}
                                                            />
                                                            <Button
                                                                disabled={true}
                                                                buttonTxt={"삭제"}
                                                                onPress={() => {
                                                                    deleteHistory(x?.idx)
                                                                }}
                                                                styles={{ width: 100, height: 30, fontSize: 14 }}
                                                            />
                                                        </p>
                                                    </div>
                                                )
                                            })}
                                        </div>

                                    </div>
                                </div>
                                <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
                                    <Button
                                        disabled={true}
                                        buttonTxt={"닫기"}
                                        onPress={() => { setpopupShow(false) }}
                                        styles={{ width: 200 }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )
}